var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cargo-advance-search",
      staticStyle: { height: "auto", width: "100%", "margin-top": "5px" }
    },
    [
      _vm.showSimple
        ? _c(
            "div",
            { staticClass: "cargo-advance-search-header" },
            [
              _c(
                "div",
                { staticClass: "cargo-advance-search-toggle-trigger" },
                [
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showAdv,
                        expression: "showAdv"
                      }
                    ],
                    staticClass: "el-icon-arrow-left",
                    style: {
                      transform: !_vm.isShowingMoreSearchCondition
                        ? "rotate(-90deg)"
                        : "rotate(90deg)"
                    },
                    attrs: { no: "upOrDown" },
                    on: { click: _vm.upOrDownSearchCondition }
                  })
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.showSimple && !_vm.isShowingMoreSearchCondition,
                      expression: "showSimple && !isShowingMoreSearchCondition"
                    }
                  ],
                  staticClass: "cargo-advance-search-quick"
                },
                [
                  _c("el-input", {
                    directives: [{ name: "focus", rawName: "v-focus" }],
                    staticStyle: { width: "200px" },
                    attrs: {
                      no: "keyWords",
                      clearable: "",
                      placeholder: _vm.simQueryPlaceholderValue,
                      spellcheck: false
                    },
                    on: { change: _vm.keyWordCharge },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.simSearch($event)
                      }
                    },
                    model: {
                      value: _vm.keyWords,
                      callback: function($$v) {
                        _vm.keyWords = $$v
                      },
                      expression: "keyWords"
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px", height: "28px" },
                      attrs: {
                        no: "Query",
                        type: "primary",
                        disabled: _vm.disabled || _vm.searchDisabled
                      },
                      on: { click: _vm.simSearch }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_Query")) + " ")]
                  )
                ],
                1
              ),
              _vm.showAdv
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowingMoreSearchCondition,
                          expression: "isShowingMoreSearchCondition"
                        }
                      ],
                      staticStyle: {
                        "margin-left": "5px",
                        "margin-right": "-5px",
                        height: "28px"
                      },
                      attrs: {
                        no: "ComplexQuery",
                        type: "primary",
                        disabled: _vm.disabled || _vm.searchDisabled
                      },
                      on: { click: _vm.advSearch }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")) + " ")]
                  )
                : _vm._e(),
              _c("cargo-button-group-slider", [_vm._t("operations")], 2),
              _vm._t("other")
            ],
            2
          )
        : _vm._e(),
      !_vm.showSimple && _vm.$slots.operations
        ? _c(
            "div",
            { staticClass: "cargo-advance-search-header" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShowingMoreSearchCondition,
                      expression: "isShowingMoreSearchCondition"
                    }
                  ],
                  staticStyle: {
                    "margin-left": "5px",
                    "margin-right": "-5px",
                    height: "28px"
                  },
                  attrs: {
                    type: "primary",
                    no: "advSearch",
                    disabled: _vm.disabled || _vm.searchDisabled
                  },
                  on: { click: _vm.advSearch }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
              ),
              _c("cargo-button-group-slider", [_vm._t("operations")], 2)
            ],
            1
          )
        : _vm._e(),
      _vm._t("searchAreaHeader"),
      _vm.showAdv
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowingMoreSearchCondition,
                  expression: "isShowingMoreSearchCondition"
                }
              ],
              staticClass: "section cargo-advance-search-more"
            },
            [
              _c(
                "div",
                { staticClass: "cargo-advance-search-more-operations" },
                [
                  _c(
                    "div",
                    [
                      !_vm.showSimple && !_vm.$slots.operations
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowingMoreSearchCondition,
                                  expression: "isShowingMoreSearchCondition"
                                }
                              ],
                              attrs: {
                                no: "advSearch2",
                                type: "primary",
                                disabled: _vm.disabled || _vm.searchDisabled
                              },
                              on: { click: _vm.advSearch }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_Query")) + " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "SaveChanges",
                            type: "primary",
                            disabled: _vm.disabled,
                            plain: ""
                          },
                          on: { click: _vm.showSaveModifiedDialog }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_SaveChanges")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "ModifyFilter",
                            type: "primary",
                            disabled: _vm.disabled,
                            plain: ""
                          },
                          on: { click: _vm.toShowConfigSearchItem }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_ModifyFilter")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "ResetFilter",
                            type: "primary",
                            disabled: _vm.disabled,
                            plain: ""
                          },
                          on: { click: _vm.toResetFields }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_ResetFilter")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "SaveAsScheme",
                            type: "primary",
                            disabled: _vm.disabled,
                            plain: ""
                          },
                          on: { click: _vm.showSaveSchemeDialog }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_SaveAsScheme")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isAppendQuery,
                              expression: "isAppendQuery"
                            }
                          ],
                          staticClass: "append-checkbox",
                          attrs: { no: "appendQuery" },
                          model: {
                            value: _vm.appendQuery,
                            callback: function($$v) {
                              _vm.appendQuery = $$v
                            },
                            expression: "appendQuery"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AppendQuery")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isCollapseList,
                              expression: "isCollapseList"
                            }
                          ],
                          staticClass: "append-checkbox",
                          staticStyle: { "margin-left": "-20px" },
                          attrs: { no: "collapseList" },
                          on: {
                            change: function($event) {
                              return _vm.clickCollapseList()
                            }
                          },
                          model: {
                            value: _vm.collapseList,
                            callback: function($$v) {
                              _vm.collapseList = $$v
                            },
                            expression: "collapseList"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CollapseList")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isBranchCooperate,
                              expression: "isBranchCooperate"
                            }
                          ],
                          staticClass: "append-checkbox",
                          staticStyle: { "margin-left": "-20px" },
                          attrs: { no: "branchCooperate" },
                          model: {
                            value: _vm.branchCooperate,
                            callback: function($$v) {
                              _vm.branchCooperate = $$v
                            },
                            expression: "branchCooperate"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_BranchCooperate"))
                          )
                        ]
                      ),
                      _vm._t("adv-operations")
                    ],
                    2
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        color: "#1F75D5",
                        "margin-right": "20px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.perConfigName))]
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-dropdown",
                        {
                          staticClass: "main-dropdown",
                          attrs: {
                            no: "QueryScheme",
                            trigger: "click",
                            placement: "bottom-start",
                            "hide-on-click": false
                          },
                          on: { command: _vm.selectedPerConfigByCommand }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                plain: "",
                                disabled: _vm.disabled
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("CargoMsg.Cargo_QueryScheme"))
                              ),
                              _c("i", {
                                staticClass: "el-icon-arrow-down el-icon--right"
                              })
                            ]
                          ),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "max-height": "300px",
                                    "overflow-y": "auto"
                                  }
                                },
                                _vm._l(_vm.perConfigs, function(item, index) {
                                  return item && !item.bDefault
                                    ? _c(
                                        "el-dropdown-item",
                                        {
                                          key: item.id + "-" + index,
                                          class: [
                                            item &&
                                            item.id === _vm.selectedConfigValue
                                              ? "activeMenu"
                                              : ""
                                          ],
                                          attrs: { command: item.id }
                                        },
                                        [_vm._v(_vm._s(item.configName) + " ")]
                                      )
                                    : _vm._e()
                                }),
                                1
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  class: [
                                    _vm.defConfig &&
                                    _vm.defConfig.id === _vm.selectedConfigValue
                                      ? "activeMenu"
                                      : ""
                                  ],
                                  attrs: { command: "default", divided: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.defConfig && _vm.defConfig.configName
                                    ) + " "
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                { attrs: { divided: "", command: "manage" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_QuerySchemeManagement"
                                      )
                                    ) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShowSearchItem,
                      expression: "isShowSearchItem"
                    }
                  ],
                  staticClass: "cargo-advance-search-form",
                  staticStyle: { "min-width": "830px", "margin-right": "10px" },
                  attrs: {
                    "label-width": "75px",
                    "label-position": "left",
                    disabled: _vm.disabled
                  }
                },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: { "flex-wrap": "wrap" },
                      attrs: { type: "flex", gutter: 6 }
                    },
                    _vm._l(_vm.multipleSelection, function(item, index) {
                      return _c(
                        "el-col",
                        _vm._b(
                          {
                            key:
                              item.itemName +
                              item.itemType +
                              index +
                              _vm.selectedConfigValue,
                            attrs: { no: item.itemName }
                          },
                          "el-col",
                          _vm.colSettings,
                          false
                        ),
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    slot: "label",
                                    disabled:
                                      _vm.getLength(
                                        _vm.i18nAdvSearch("" + item.itemLabel)
                                      ) < 12,
                                    effect: "dark",
                                    content: item.itemTipLabel
                                      ? _vm.i18nAdvSearch(
                                          "" + item.itemTipLabel
                                        )
                                      : _vm.i18nAdvSearch("" + item.itemLabel),
                                    placement: "top",
                                    size: "mini"
                                  },
                                  slot: "label"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        width: "100%",
                                        overflow: "hidden",
                                        "white-space": "nowrap",
                                        "text-overflow": "ellipsis"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.i18nAdvSearch("" + item.itemLabel)
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        item.itemType !== "sopStateTrack" &&
                                        item.itemType !== "ediStateQuery" &&
                                        _vm.showCondition,
                                      expression:
                                        "item.itemType !== 'sopStateTrack' && item.itemType !== 'ediStateQuery' && showCondition"
                                    }
                                  ],
                                  staticStyle: {
                                    display: "inline-block",
                                    "margin-right": "3px"
                                  }
                                },
                                [
                                  item.itemCondition &&
                                  item.itemCondition.length > 0
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: {
                                            width: "77px",
                                            display: "inline-block"
                                          },
                                          attrs: {
                                            no: "condition",
                                            disabled: item.lock,
                                            size: "mini",
                                            placeholder: _vm.$t(
                                              "common.pleaseChoose"
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.onCondChange(
                                                $event,
                                                item
                                              )
                                            }
                                          },
                                          model: {
                                            value: item.defaultConditionVal,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item,
                                                "defaultConditionVal",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.defaultConditionVal"
                                          }
                                        },
                                        _vm._l(
                                          item.itemCondition || [],
                                          function(cond, index) {
                                            return _c("el-option", {
                                              key: cond.code + "-" + index,
                                              attrs: {
                                                label: _vm.i18nAdvSearch(
                                                  "advanceSearchForm." +
                                                    cond.englishName
                                                ),
                                                value: cond.code
                                              }
                                            })
                                          }
                                        ),
                                        1
                                      )
                                    : _c("div", {
                                        staticStyle: {
                                          width: "80px",
                                          display: "inline-block"
                                        }
                                      })
                                ],
                                1
                              ),
                              item.itemType === "input"
                                ? [
                                    item.subType === "bigdecimalForPositive"
                                      ? [
                                          _c("el-input-number", {
                                            ref:
                                              "" +
                                              item.itemName +
                                              item.itemType +
                                              _vm.selectedConfigValue,
                                            refInFor: true,
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              disabled: item.lock,
                                              max: 99999999,
                                              size: "mini",
                                              precision: 2,
                                              step: 1,
                                              "controls-position": "right",
                                              placeholder: _vm.emptyPlaceholder
                                            },
                                            nativeOn: {
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onAdvSelectEnter(
                                                  $event
                                                )
                                              },
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onInputEnter($event)
                                              }
                                            },
                                            model: {
                                              value: item.itemValue,
                                              callback: function($$v) {
                                                _vm.$set(item, "itemValue", $$v)
                                              },
                                              expression: "item.itemValue"
                                            }
                                          })
                                        ]
                                      : item.subType === "bigdecimalrange"
                                      ? [
                                          _c("el-input-number", {
                                            ref:
                                              "" +
                                              item.itemName +
                                              item.itemType +
                                              _vm.selectedConfigValue,
                                            refInFor: true,
                                            staticStyle: { width: "49%" },
                                            attrs: {
                                              no: "header",
                                              disabled: item.lock,
                                              min: 0,
                                              max: item.itemValue2 || 99999999,
                                              size: "mini",
                                              precision:
                                                item.itemName ===
                                                "job.QUANTITY_CONTRACT"
                                                  ? 0
                                                  : 2,
                                              step: 1,
                                              "controls-position": "right",
                                              placeholder: _vm.emptyPlaceholder
                                            },
                                            on: {
                                              blur: function(e) {
                                                if (e.target.value <= 0) {
                                                  item.itemValue1 = undefined
                                                }
                                              }
                                            },
                                            nativeOn: {
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onAdvSelectEnter(
                                                  $event
                                                )
                                              },
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onInputEnter($event)
                                              }
                                            },
                                            model: {
                                              value: item.itemValue1,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "itemValue1",
                                                  $$v
                                                )
                                              },
                                              expression: "item.itemValue1"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticStyle: { width: "2%" } },
                                            [_vm._v("-")]
                                          ),
                                          _c("el-input-number", {
                                            ref:
                                              "" +
                                              item.itemName +
                                              item.itemType +
                                              _vm.selectedConfigValue,
                                            refInFor: true,
                                            staticStyle: { width: "49%" },
                                            attrs: {
                                              no: "tail",
                                              disabled: item.lock,
                                              min: item.itemValue1 || 0,
                                              max: 99999999,
                                              size: "mini",
                                              precision:
                                                item.itemName ===
                                                "job.QUANTITY_CONTRACT"
                                                  ? 0
                                                  : 2,
                                              step: 1,
                                              "controls-position": "right",
                                              placeholder: _vm.emptyPlaceholder
                                            },
                                            on: {
                                              blur: function(e) {
                                                if (e.target.value <= 0) {
                                                  item.itemValue2 = undefined
                                                }
                                              }
                                            },
                                            nativeOn: {
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onAdvSelectEnter(
                                                  $event
                                                )
                                              },
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onInputEnter($event)
                                              }
                                            },
                                            model: {
                                              value: item.itemValue2,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "itemValue2",
                                                  $$v
                                                )
                                              },
                                              expression: "item.itemValue2"
                                            }
                                          })
                                        ]
                                      : item.subType ===
                                        "bigdecimalrangeForPositive"
                                      ? [
                                          _c("el-input-number", {
                                            ref:
                                              "" +
                                              item.itemName +
                                              item.itemType +
                                              _vm.selectedConfigValue,
                                            refInFor: true,
                                            staticStyle: { width: "49%" },
                                            attrs: {
                                              no: "header",
                                              disabled: item.lock,
                                              max: item.itemValue2 || 99999999,
                                              precision: 2,
                                              step: 1,
                                              size: "mini",
                                              "controls-position": "right",
                                              placeholder: _vm.emptyPlaceholder
                                            },
                                            nativeOn: {
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onAdvSelectEnter(
                                                  $event
                                                )
                                              },
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onInputEnter($event)
                                              }
                                            },
                                            model: {
                                              value: item.itemValue1,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "itemValue1",
                                                  $$v
                                                )
                                              },
                                              expression: "item.itemValue1"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticStyle: { width: "2%" } },
                                            [_vm._v("-")]
                                          ),
                                          _c("el-input-number", {
                                            ref:
                                              "" +
                                              item.itemName +
                                              item.itemType +
                                              _vm.selectedConfigValue,
                                            refInFor: true,
                                            staticStyle: { width: "49%" },
                                            attrs: {
                                              no: "tail",
                                              disabled: item.lock,
                                              min: item.itemValue1 || 0,
                                              max: 99999999,
                                              precision: 2,
                                              step: 1,
                                              size: "mini",
                                              "controls-position": "right",
                                              placeholder: _vm.emptyPlaceholder
                                            },
                                            nativeOn: {
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onAdvSelectEnter(
                                                  $event
                                                )
                                              },
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onInputEnter($event)
                                              }
                                            },
                                            model: {
                                              value: item.itemValue2,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "itemValue2",
                                                  $$v
                                                )
                                              },
                                              expression: "item.itemValue2"
                                            }
                                          })
                                        ]
                                      : item.subType === "numberText"
                                      ? [
                                          _c("el-input", {
                                            staticClass: "textInput",
                                            attrs: {
                                              value: item.itemValue,
                                              clearable: "",
                                              size: "mini",
                                              placeholder: _vm.emptyPlaceholder
                                            },
                                            on: {
                                              input: function(value) {
                                                item.itemValue = value.replace(
                                                  /[^\d]/g,
                                                  ""
                                                )
                                              }
                                            },
                                            nativeOn: {
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onAdvSelectEnter(
                                                  $event
                                                )
                                              },
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onInputEnter($event)
                                              }
                                            }
                                          })
                                        ]
                                      : item.subType === "charRange"
                                      ? [
                                          _c("el-input", {
                                            ref:
                                              "" +
                                              item.itemName +
                                              item.itemType +
                                              _vm.selectedConfigValue,
                                            refInFor: true,
                                            staticStyle: { width: "49%" },
                                            attrs: {
                                              no: "header",
                                              disabled: item.lock,
                                              clearable: "",
                                              size: "mini",
                                              placeholder: _vm.$t(
                                                "CargoMsg.Cargo_RangeSmaller"
                                              )
                                            },
                                            nativeOn: {
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onAdvSelectEnter(
                                                  $event
                                                )
                                              },
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onInputEnter($event)
                                              }
                                            },
                                            model: {
                                              value: item.itemValue1,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "itemValue1",
                                                  $$v
                                                )
                                              },
                                              expression: "item.itemValue1"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticStyle: { width: "2%" } },
                                            [_vm._v("-")]
                                          ),
                                          _c("el-input", {
                                            ref:
                                              "" +
                                              item.itemName +
                                              item.itemType +
                                              _vm.selectedConfigValue,
                                            refInFor: true,
                                            staticStyle: { width: "49%" },
                                            attrs: {
                                              no: "tail",
                                              disabled: item.lock,
                                              clearable: "",
                                              size: "mini",
                                              placeholder: _vm.$t(
                                                "CargoMsg.Cargo_RangeSmaller"
                                              )
                                            },
                                            nativeOn: {
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onAdvSelectEnter(
                                                  $event
                                                )
                                              },
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onInputEnter($event)
                                              }
                                            },
                                            model: {
                                              value: item.itemValue2,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "itemValue2",
                                                  $$v
                                                )
                                              },
                                              expression: "item.itemValue2"
                                            }
                                          })
                                        ]
                                      : item.subType ===
                                        "bigdecimalrangeWithPrecision"
                                      ? [
                                          _c("el-input-number", {
                                            ref:
                                              "" +
                                              item.itemName +
                                              item.itemType +
                                              _vm.selectedConfigValue,
                                            refInFor: true,
                                            staticStyle: { width: "49%" },
                                            attrs: {
                                              no: "header",
                                              disabled: item.lock,
                                              min: 0,
                                              max: item.itemValue2 || 99999999,
                                              size: "mini",
                                              precision: item.precision
                                                ? item.precision
                                                : 0,
                                              step: 1,
                                              "controls-position": "right",
                                              placeholder: _vm.emptyPlaceholder
                                            },
                                            on: {
                                              blur: function(e) {
                                                if (e.target.value <= 0) {
                                                  item.itemValue1 = undefined
                                                }
                                              }
                                            },
                                            nativeOn: {
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onAdvSelectEnter(
                                                  $event
                                                )
                                              },
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onInputEnter($event)
                                              }
                                            },
                                            model: {
                                              value: item.itemValue1,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "itemValue1",
                                                  $$v
                                                )
                                              },
                                              expression: "item.itemValue1"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticStyle: { width: "2%" } },
                                            [_vm._v("-")]
                                          ),
                                          _c("el-input-number", {
                                            ref:
                                              "" +
                                              item.itemName +
                                              item.itemType +
                                              _vm.selectedConfigValue,
                                            refInFor: true,
                                            staticStyle: { width: "49%" },
                                            attrs: {
                                              no: "tail",
                                              disabled: item.lock,
                                              min: item.itemValue1 || 0,
                                              max: 99999999,
                                              size: "mini",
                                              precision: item.precision
                                                ? item.precision
                                                : 0,
                                              step: 1,
                                              "controls-position": "right",
                                              placeholder: _vm.emptyPlaceholder
                                            },
                                            on: {
                                              blur: function(e) {
                                                if (e.target.value <= 0) {
                                                  item.itemValue2 = undefined
                                                }
                                              }
                                            },
                                            nativeOn: {
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onAdvSelectEnter(
                                                  $event
                                                )
                                              },
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onInputEnter($event)
                                              }
                                            },
                                            model: {
                                              value: item.itemValue2,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "itemValue2",
                                                  $$v
                                                )
                                              },
                                              expression: "item.itemValue2"
                                            }
                                          })
                                        ]
                                      : item.defaultConditionVal ===
                                          "IS IT EMPTY" ||
                                        item.defaultConditionVal ===
                                          "IS IT NOT EMPTY"
                                      ? [
                                          _c("cargo-advance-select", {
                                            ref:
                                              "" +
                                              item.itemName +
                                              item.itemType +
                                              _vm.selectedConfigValue,
                                            refInFor: true,
                                            attrs: {
                                              disabled: item.lock,
                                              "select-type":
                                                _vm.selectTypeNames[
                                                  item.dataCacheKey
                                                ],
                                              "callback-params": {
                                                refCode: item.itemName,
                                                fieldType: item.fieldType
                                              },
                                              "default-value": item.itemValue,
                                              "options-width": "450px",
                                              placeholder: _vm.emptyPlaceholder,
                                              headers: item.headers || [],
                                              fields: item.fields || [],
                                              "tag-name": item.tagName,
                                              "tag-value": item.tagValue
                                            },
                                            on: {
                                              enter: _vm.onAdvSelectEnter,
                                              parentCallBack:
                                                _vm.getValueFromChild
                                            }
                                          })
                                        ]
                                      : [
                                          _c("el-input", {
                                            staticClass: "textInput",
                                            attrs: {
                                              disabled:
                                                item.defaultConditionVal ===
                                                  "IS NULL" || item.lock,
                                              clearable: "",
                                              size: "mini",
                                              placeholder: _vm.emptyPlaceholder
                                            },
                                            nativeOn: {
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onAdvSelectEnter(
                                                  $event
                                                )
                                              },
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.onInputEnter($event)
                                              }
                                            },
                                            model: {
                                              value: item.itemValue,
                                              callback: function($$v) {
                                                _vm.$set(item, "itemValue", $$v)
                                              },
                                              expression: "item.itemValue"
                                            }
                                          })
                                        ]
                                  ]
                                : _vm._e(),
                              item.itemType === "input-m"
                                ? _c(
                                    "el-input",
                                    {
                                      ref:
                                        "" +
                                        item.itemName +
                                        item.itemType +
                                        _vm.selectedConfigValue,
                                      refInFor: true,
                                      attrs: {
                                        size: "mini",
                                        disabled: "",
                                        placeholder: _vm.emptyPlaceholder
                                      },
                                      nativeOn: {
                                        keydown: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.onAdvSelectEnter($event)
                                        },
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.onInputEnter($event)
                                        }
                                      },
                                      model: {
                                        value: item.itemValue,
                                        callback: function($$v) {
                                          _vm.$set(item, "itemValue", $$v)
                                        },
                                        expression: "item.itemValue"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            slot: "append",
                                            size: "mini",
                                            disabled: item.lock
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.toShowEditTextArea(
                                                item
                                              )
                                            }
                                          },
                                          slot: "append"
                                        },
                                        [_vm._v("... ")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              item.itemType === "multiText" ||
                              item.itemType === "multiTextAndExclude" ||
                              (item.itemType === "overseaWarehouse" &&
                                item.subType === "multiText" &&
                                "BATCH" === item.defaultConditionVal)
                                ? _c("cargo-multi-line-text-popover", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      "show-popover":
                                        "BATCH" === item.defaultConditionVal ||
                                        "BATCH_EXCLUDE" ===
                                          item.defaultConditionVal ||
                                        "REGEXP" === item.defaultConditionVal,
                                      separator:
                                        "REGEXP" === item.defaultConditionVal
                                          ? "|"
                                          : ",",
                                      disabled: item.lock,
                                      value: item.itemValue,
                                      "visible-arrow": false,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      "update:value": function($event) {
                                        return _vm.$set(
                                          item,
                                          "itemValue",
                                          $event
                                        )
                                      },
                                      inputEnter: _vm.onInputEnter
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "multiText2" ||
                              item.itemType === "multiText3"
                                ? _c("cargo-multi-line-text-popover", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      "show-popover":
                                        "BATCH" === item.defaultConditionVal ||
                                        "BATCH_EXCLUDE" ===
                                          item.defaultConditionVal ||
                                        "REGEXP" === item.defaultConditionVal,
                                      separator:
                                        "REGEXP" === item.defaultConditionVal
                                          ? "|"
                                          : ",",
                                      disabled: item.lock,
                                      "input-disabled":
                                        item.defaultConditionVal ===
                                          "IS NULL" ||
                                        item.defaultConditionVal ===
                                          "IS NOT NULL",
                                      value: item.itemValue,
                                      "visible-arrow": false,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      "update:value": function($event) {
                                        return _vm.$set(
                                          item,
                                          "itemValue",
                                          $event
                                        )
                                      },
                                      inputEnter: _vm.onInputEnter
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "sopStateTrack"
                                ? [
                                    _c("el-input", {
                                      ref:
                                        "" +
                                        item.itemName +
                                        item.itemType +
                                        _vm.selectedConfigValue,
                                      refInFor: true,
                                      attrs: {
                                        size: "mini",
                                        readonly: "",
                                        placeholder: _vm.$t(
                                          "advanceSearchForm.doubleClickToSelect"
                                        )
                                      },
                                      nativeOn: {
                                        dblclick: function($event) {
                                          return _vm.toShowSopStateTrack(item)
                                        }
                                      },
                                      model: {
                                        value:
                                          _vm.sopStateTrack.currentItem
                                            .txtContent,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.sopStateTrack.currentItem,
                                            "txtContent",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "sopStateTrack.currentItem.txtContent"
                                      }
                                    }),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !!_vm.sopStateTrack
                                              .currentItem.txtContent,
                                            expression:
                                              "!!sopStateTrack.currentItem.txtContent"
                                          }
                                        ],
                                        attrs: {
                                          size: "mini",
                                          disabled: item.lock
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toClearSopStateTrack(
                                              item
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Message.Clear")) + " "
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e(),
                              item.itemType === "ediStateQuery"
                                ? [
                                    _c("el-input", {
                                      ref:
                                        "" +
                                        item.itemName +
                                        item.itemType +
                                        _vm.selectedConfigValue,
                                      refInFor: true,
                                      attrs: {
                                        value: item.txtContent,
                                        size: "mini",
                                        readonly: "",
                                        placeholder: _vm.$t(
                                          "Message.DoubleClickToSelectState"
                                        )
                                      },
                                      nativeOn: {
                                        dblclick: function($event) {
                                          return _vm.toShowEdiStateQueryDialog(
                                            item
                                          )
                                        }
                                      }
                                    }),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !!item.txtContent,
                                            expression: "!!item.txtContent"
                                          }
                                        ],
                                        attrs: {
                                          size: "mini",
                                          disabled: item.lock
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toClearSpecialQuery(item)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("CargoMsg.Cargo_Clear"))
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e(),
                              item.itemType === "date" &&
                              item.subType === "daymicDate"
                                ? [
                                    item.defaultConditionVal === "RANGE"
                                      ? _c("cargo-date-time-picker", {
                                          key: "2",
                                          attrs: {
                                            disabled: item.lock,
                                            type: "daterange",
                                            "value-format": "yyyy-MM-dd",
                                            size: "mini",
                                            clearable: "",
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          nativeOn: {
                                            keydown: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              $event.preventDefault()
                                              return _vm.onAdvSelectEnter(
                                                $event
                                              )
                                            }
                                          },
                                          model: {
                                            value: item.itemValue,
                                            callback: function($$v) {
                                              _vm.$set(item, "itemValue", $$v)
                                            },
                                            expression: "item.itemValue"
                                          }
                                        })
                                      : item.defaultConditionVal === 99
                                      ? _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              disabled: item.lock,
                                              placeholder: _vm.emptyPlaceholder
                                            },
                                            model: {
                                              value: item.itemValue,
                                              callback: function($$v) {
                                                _vm.$set(item, "itemValue", $$v)
                                              },
                                              expression: "item.itemValue"
                                            }
                                          },
                                          _vm._l(_vm.shortcutDates, function(
                                            _item,
                                            index
                                          ) {
                                            return _c("el-option", {
                                              key: _item.value + "-" + index,
                                              attrs: {
                                                label: _vm.i18nAdvSearch(
                                                  _item.label
                                                ),
                                                value: _item.value
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      : _c("cargo-date-time-picker", {
                                          key: "1",
                                          attrs: {
                                            disabled: item.lock,
                                            "value-format": "yyyy-MM-dd",
                                            size: "mini",
                                            clearable: "",
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          nativeOn: {
                                            keydown: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              $event.preventDefault()
                                              return _vm.onAdvSelectEnter(
                                                $event
                                              )
                                            }
                                          },
                                          model: {
                                            value: item.itemValue,
                                            callback: function($$v) {
                                              _vm.$set(item, "itemValue", $$v)
                                            },
                                            expression: "item.itemValue"
                                          }
                                        })
                                  ]
                                : _vm._e(),
                              item.itemType === "date"
                                ? [
                                    item.defaultConditionVal !== "DATE ITEM"
                                      ? [
                                          _c("cargo-date-time-picker", {
                                            ref:
                                              "" +
                                              item.itemName +
                                              item.itemType +
                                              _vm.selectedConfigValue,
                                            refInFor: true,
                                            staticStyle: { width: "49%" },
                                            attrs: {
                                              no: "begin",
                                              disabled:
                                                item.lock ||
                                                item.defaultConditionVal !==
                                                  "RANGE",
                                              "value-format": "yyyy-MM-dd",
                                              type: "date",
                                              clearable: "",
                                              "picker-options": {
                                                disabledDate: function(time) {
                                                  var endDate = item
                                                    .itemValue[1]
                                                    ? new Date(
                                                        item.itemValue[1] +
                                                          " 23:59:59"
                                                      )
                                                    : null
                                                  if (endDate) {
                                                    // 基础限制：限制开始日期不能晚于结束日期
                                                    if (
                                                      time.getTime() >
                                                      endDate.getTime()
                                                    ) {
                                                      return true
                                                    }
                                                    //判断是否启用 3 个月限制
                                                    if (
                                                      item.filterType ===
                                                      "THREE_MONTH"
                                                    ) {
                                                      return (
                                                        time.getTime() <
                                                        _vm
                                                          .getThreeMonthsAgo(
                                                            endDate
                                                          )
                                                          .getTime() -
                                                          24 * 60 * 60 * 1000
                                                      ) //如果大于3个月之前，不可操作
                                                    }
                                                  }
                                                  return false
                                                }
                                              },
                                              placeholder: _vm.emptyPlaceholder
                                            },
                                            on: {
                                              focus: function() {
                                                return _vm.handleDateRangeFocus(
                                                  item
                                                )
                                              },
                                              blur: function() {
                                                return _vm.handleDateRangeBlur(
                                                  item
                                                )
                                              },
                                              change: function() {
                                                return _vm.datePickerChange(
                                                  item
                                                )
                                              }
                                            },
                                            model: {
                                              value: item.itemValue[0],
                                              callback: function($$v) {
                                                _vm.$set(item.itemValue, 0, $$v)
                                              },
                                              expression: "item.itemValue[0]"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticStyle: { width: "2%" } },
                                            [_vm._v(" - ")]
                                          ),
                                          _c("cargo-date-time-picker", {
                                            ref:
                                              "" +
                                              item.itemName +
                                              item.itemType +
                                              _vm.selectedConfigValue,
                                            refInFor: true,
                                            staticStyle: { width: "49%" },
                                            attrs: {
                                              no: "end",
                                              disabled:
                                                item.lock ||
                                                item.defaultConditionVal !==
                                                  "RANGE",
                                              "value-format": "yyyy-MM-dd",
                                              type: "date",
                                              clearable: "",
                                              "picker-options": {
                                                disabledDate: function(time) {
                                                  var startDate = item
                                                    .itemValue[0]
                                                    ? new Date(
                                                        item.itemValue[0] +
                                                          " 00:00:00"
                                                      )
                                                    : null
                                                  if (startDate) {
                                                    // 基础限制：结束日期不能早于开始日期
                                                    if (
                                                      time.getTime() <
                                                      startDate.getTime()
                                                    ) {
                                                      return true
                                                    }
                                                    //判断是否启用 3 个月限制
                                                    if (
                                                      item.filterType ===
                                                      "THREE_MONTH"
                                                    ) {
                                                      return (
                                                        time.getTime() >
                                                        _vm
                                                          .getThreeMonthsLater(
                                                            startDate
                                                          )
                                                          .getTime()
                                                      ) //如果结束日期在3个月之后不可操作
                                                    }
                                                  }
                                                  return false
                                                }
                                              },
                                              placeholder: _vm.emptyPlaceholder
                                            },
                                            on: {
                                              focus: function() {
                                                return _vm.handleDateRangeFocus(
                                                  item
                                                )
                                              },
                                              blur: function() {
                                                return _vm.handleDateRangeBlur(
                                                  item
                                                )
                                              },
                                              change: function() {
                                                return _vm.datePickerChange(
                                                  item
                                                )
                                              }
                                            },
                                            model: {
                                              value: item.itemValue[1],
                                              callback: function($$v) {
                                                _vm.$set(item.itemValue, 1, $$v)
                                              },
                                              expression: "item.itemValue[1]"
                                            }
                                          })
                                        ]
                                      : [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                disabled: item.lock,
                                                placeholder:
                                                  _vm.emptyPlaceholder
                                              },
                                              model: {
                                                value: item.itemValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "itemValue",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.itemValue"
                                              }
                                            },
                                            _vm._l(
                                              item.dateItemExtend === 1
                                                ? _vm.shortcutDatesExtend.concat(
                                                    _vm.shortcutDates
                                                  )
                                                : _vm.shortcutDates,
                                              function(_item, index) {
                                                return _c("el-option", {
                                                  key:
                                                    _item.value + "-" + index,
                                                  attrs: {
                                                    label: _vm.i18nAdvSearch(
                                                      _item.label
                                                    ),
                                                    value: _item.value
                                                  }
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        ]
                                  ]
                                : _vm._e(),
                              item.itemType === "singleDate"
                                ? [
                                    _c("cargo-date-time-picker", {
                                      key: "1",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled: item.lock,
                                        "value-format": "yyyy-MM-dd",
                                        size: "mini",
                                        clearable: "",
                                        placeholder: _vm.emptyPlaceholder
                                      },
                                      nativeOn: {
                                        keydown: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.onAdvSelectEnter($event)
                                        }
                                      },
                                      model: {
                                        value: item.itemValue,
                                        callback: function($$v) {
                                          _vm.$set(item, "itemValue", $$v)
                                        },
                                        expression: "item.itemValue"
                                      }
                                    })
                                  ]
                                : _vm._e(),
                              item.itemType === "select" &&
                              item.valueExpression &&
                              item.valueExpression.valueType === "static"
                                ? _c(
                                    "el-select",
                                    {
                                      ref:
                                        "" +
                                        item.itemName +
                                        item.itemType +
                                        _vm.selectedConfigValue,
                                      refInFor: true,
                                      staticClass: "multi-select",
                                      attrs: {
                                        disabled: item.lock,
                                        multiple: item.multiple === 1,
                                        "collapse-tags": true,
                                        filterable: "",
                                        clearable: "",
                                        size: "mini",
                                        placeholder: _vm.emptyPlaceholder
                                      },
                                      on: {
                                        change: function() {
                                          return _vm.convertSelectedToText(
                                            "" +
                                              item.itemName +
                                              item.itemType +
                                              _vm.selectedConfigValue
                                          )
                                        }
                                      },
                                      nativeOn: {
                                        keydown: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.onAdvSelectEnter($event)
                                        }
                                      },
                                      model: {
                                        value: item.itemValue,
                                        callback: function($$v) {
                                          _vm.$set(item, "itemValue", $$v)
                                        },
                                        expression: "item.itemValue"
                                      }
                                    },
                                    _vm._l(
                                      item.valueExpression.valueContent,
                                      function(_item, index) {
                                        return _c("el-option", {
                                          key: _item.code + "-" + index,
                                          attrs: {
                                            label:
                                              _vm.$store.getters.language ===
                                              "zh"
                                                ? _item.chineseName
                                                : _item.englishName,
                                            value: _item.code
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                              item.itemType === "stateTypes"
                                ? _c(
                                    "el-select",
                                    {
                                      ref:
                                        "" +
                                        item.itemName +
                                        item.itemType +
                                        _vm.selectedConfigValue,
                                      refInFor: true,
                                      staticClass: "multi-select",
                                      attrs: {
                                        disabled: item.lock,
                                        multiple: item.multiple === 1,
                                        clearable: "",
                                        "collapse-tags": "",
                                        size: "mini",
                                        placeholder: _vm.emptyPlaceholder
                                      },
                                      on: {
                                        change: function() {
                                          return _vm.convertSelectedToText(
                                            "" +
                                              item.itemName +
                                              item.itemType +
                                              _vm.selectedConfigValue
                                          )
                                        }
                                      },
                                      nativeOn: {
                                        keydown: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.onAdvSelectEnter($event)
                                        }
                                      },
                                      model: {
                                        value: item.itemValue,
                                        callback: function($$v) {
                                          _vm.$set(item, "itemValue", $$v)
                                        },
                                        expression: "item.itemValue"
                                      }
                                    },
                                    _vm._l(_vm.stateTypes, function(
                                      _item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: _item.code + "-" + index,
                                        attrs: {
                                          label:
                                            _vm.$store.getters.language === "zh"
                                              ? _item.chineseName
                                              : _item.englishName,
                                          value: _item.code
                                        }
                                      })
                                    }),
                                    1
                                  )
                                : _vm._e(),
                              item.itemType === "railwayLine2"
                                ? _c("cargo-advance-select", {
                                    key:
                                      "rl2-" +
                                      item.itemName +
                                      "-" +
                                      item.defaultConditionVal +
                                      "-" +
                                      _vm.selectedConfigValue,
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      filterable: "",
                                      disabled: item.lock,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-multiple-value":
                                        item.defaultConditionVal ===
                                          _vm.AdvancedSearchConsts.OPERATOR_IN
                                            .code && item.multiple === 1
                                          ? item.itemValue instanceof Array
                                            ? item.itemValue
                                            : []
                                          : [],
                                      "default-value":
                                        item.defaultConditionVal ===
                                          _vm.AdvancedSearchConsts.OPERATOR_IN
                                            .code && item.multiple === 1
                                          ? ""
                                          : item.itemValue instanceof Array
                                          ? item.itemValue[0] || ""
                                          : item.itemValue,
                                      multiple:
                                        item.multiple == 1 &&
                                        item.defaultConditionVal ===
                                          _vm.AdvancedSearchConsts.OPERATOR_IN
                                            .code,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_RailwayLine,
                                      "method-params": {},
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "roleType"
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        width: "100%"
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        ref:
                                          "" +
                                          item.itemName +
                                          item.itemType +
                                          _vm.selectedConfigValue,
                                        refInFor: true,
                                        attrs: {
                                          no: "roleType",
                                          filterable: "",
                                          clearable: false,
                                          disabled: item.lock,
                                          "callback-params": {
                                            refCode: item.itemName
                                          },
                                          "default-value": item.itemValue,
                                          "select-type":
                                            _vm.selectTypeNames
                                              .local_cache_CargoOfRoleType,
                                          "static-options":
                                            item.dataProvider ||
                                            (item.valueExpression
                                              ? item.valueExpression
                                                  .valueContent
                                              : null),
                                          "method-params": {},
                                          headers: item.headers || [],
                                          fields: item.fields || [
                                            _vm.$store.getters.language === "zh"
                                              ? "chineseName"
                                              : "englishName"
                                          ],
                                          "tag-name":
                                            _vm.$store.getters.language === "zh"
                                              ? "chineseName"
                                              : "englishName",
                                          "tag-value": item.tagValue,
                                          placeholder: _vm.emptyPlaceholder
                                        },
                                        on: {
                                          enter: _vm.onAdvSelectEnter,
                                          parentCallBack: _vm.getValueFromChild
                                        }
                                      }),
                                      item.cascade
                                        ? _c("cargo-advance-select", {
                                            ref:
                                              "" +
                                              item.cascade.itemName +
                                              item.cascade.itemType +
                                              _vm.selectedConfigValue,
                                            refInFor: true,
                                            staticStyle: {
                                              "margin-left": "3px"
                                            },
                                            attrs: {
                                              no: "roleTypeUser",
                                              url:
                                                _vm.url.sys
                                                  .getUsersByPrivilegeDetail,
                                              cache: false,
                                              filterable: "",
                                              "method-params": {
                                                category: "role",
                                                shape: "",
                                                officeId: ""
                                              },
                                              "callback-params": {
                                                refCode: item.cascade.itemName,
                                                cascade: true,
                                                superItem: item
                                              },
                                              "default-value":
                                                item.cascade.itemValue,
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .basic_data_User,
                                              headers:
                                                item.cascade.headers || [],
                                              fields: item.cascade.fields || [
                                                _vm.$store.getters.language ===
                                                "zh"
                                                  ? "chineseName"
                                                  : "englishName"
                                              ],
                                              "tag-name": item.cascade.tagName,
                                              "tag-value":
                                                item.cascade.tagValue,
                                              placeholder: _vm.emptyPlaceholder
                                            },
                                            on: {
                                              enter: _vm.onAdvSelectEnter,
                                              parentCallBack: function(obj) {
                                                return (item.cascade.itemValue =
                                                  obj.value)
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              item.itemType === "vessel"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      filterable: "",
                                      disabled: item.lock,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-multiple-value":
                                        item.multiple === 1
                                          ? item.itemValue
                                          : [],
                                      "default-value":
                                        item.multiple === 1
                                          ? ""
                                          : item.itemValue,
                                      multiple: item.multiple == 1,
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Vessel,
                                      "method-params": {},
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: function(obj) {
                                        item.vesselId = obj.vesselId
                                        _vm.getValueFromChild(obj)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "vessel" && item.cascade
                                ? [
                                    !item.itemValue
                                      ? _c("el-input", {
                                          attrs: {
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              $event.preventDefault()
                                              return _vm.onInputEnter($event)
                                            }
                                          },
                                          model: {
                                            value: item.cascade.itemValue,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item.cascade,
                                                "itemValue",
                                                $$v
                                              )
                                            },
                                            expression: "item.cascade.itemValue"
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          ref:
                                            "" +
                                            item.cascade.itemName +
                                            item.cascade.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            filterable: "",
                                            disabled: item.cascade.lock,
                                            url:
                                              _vm.url.mdm.getVoyagesByVesselId,
                                            cache: false,
                                            "allow-create": "",
                                            "method-params": {
                                              vesselId: item.vesselId || " "
                                            },
                                            "callback-params": {
                                              refCode: item.cascade.itemName,
                                              cascade: true,
                                              superItem: item
                                            },
                                            "default-value":
                                              item.cascade.itemValue,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .static_data_Voyage,
                                            headers: item.cascade.headers || [],
                                            fields: item.cascade.fields || [],
                                            "tag-name": item.cascade.tagName,
                                            "tag-value": item.cascade.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack: function(obj) {
                                              return (item.cascade.itemValue =
                                                obj.value)
                                            }
                                          }
                                        })
                                  ]
                                : _vm._e(),
                              item.itemType === "seaport"
                                ? [
                                    item.defaultConditionVal === "IN" ||
                                    item.defaultConditionVal === "NOT IN"
                                      ? _c("cargo-advance-select", {
                                          key: "seaport-multiple",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            filterable: "",
                                            "callback-params": {
                                              refCode: item.itemName,
                                              itemType: "seaport"
                                            },
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Seaport,
                                            "default-multiple-value":
                                              item.itemValue instanceof Array
                                                ? item.itemValue
                                                : [],
                                            "method-params": {},
                                            multiple: true,
                                            disabled: item.lock,
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          key: "seaport-single",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            filterable: "",
                                            "callback-params": {
                                              refCode: item.itemName,
                                              itemType: "seaport"
                                            },
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Seaport,
                                            "default-value":
                                              item.itemValue instanceof Array
                                                ? ""
                                                : item.itemValue,
                                            "method-params": {},
                                            disabled: item.lock,
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                  ]
                                : _vm._e(),
                              item.itemType === "airport"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      filterable: "",
                                      disabled: item.lock,
                                      "callback-params": {
                                        refCode: item.itemName,
                                        itemType: "airport"
                                      },
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Airport,
                                      "default-value": item.itemValue,
                                      "method-params": {},
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "country"
                                ? [
                                    item.defaultConditionVal === "IN" ||
                                    item.defaultConditionVal === "NOT IN"
                                      ? _c("cargo-advance-select", {
                                          key: "country-multiple",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Country,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            url: "",
                                            filterable: "",
                                            multiple: true,
                                            disabled: item.lock,
                                            "default-multiple-value":
                                              item.multiple === 1
                                                ? item.itemValue
                                                : [],
                                            "default-value":
                                              item.multiple === 1
                                                ? ""
                                                : item.itemValue,
                                            "options-width": "200px",
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Country,
                                            filterable: "",
                                            disabled: item.lock,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            "default-value": item.itemValue,
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var ref_option = ref.option
                                                  var item = ref_option.item
                                                  var fields = ref_option.fields
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          display: "flex",
                                                          "justify-content":
                                                            "space-between",
                                                          width: "400px"
                                                        }
                                                      },
                                                      _vm._l(fields, function(
                                                        field,
                                                        index
                                                      ) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key:
                                                              field +
                                                              "-" +
                                                              index,
                                                            staticStyle: {
                                                              width: "30%"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item[field]
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      }),
                                                      0
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                  ]
                                : _vm._e(),
                              item.itemType === "userSea" ||
                              item.itemType === "user" ||
                              item.itemType === "user2"
                                ? [
                                    item.defaultConditionVal === "IN" ||
                                    item.defaultConditionVal === "NOT IN"
                                      ? _c("cargo-advance-select", {
                                          key: "user-multiple",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_User,
                                            url: item.lock
                                              ? ""
                                              : _vm.url.sys
                                                  .getUsersByPrivilegeDetail,
                                            cache: item.lock,
                                            "method-params": Object.assign(
                                              {
                                                officeId:
                                                  _vm.$store.getters
                                                    .currentOfficeId
                                              },
                                              item.subType
                                            ),
                                            "clear-not-match": !item.lock,
                                            filterable: "",
                                            disabled:
                                              item.lock ||
                                              item.defaultConditionVal ===
                                                _vm.AdvancedSearchConsts
                                                  .OPERATOR_IS_NULL.code,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            "default-multiple-value":
                                              item.itemValue instanceof Array
                                                ? item.itemValue
                                                : [],
                                            multiple: true,
                                            "callback-method-type": "obj",
                                            "options-width": "300px",
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          key: "user-single",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_User,
                                            url: item.lock
                                              ? ""
                                              : _vm.url.sys
                                                  .getUsersByPrivilegeDetail,
                                            cache: item.lock,
                                            "method-params": Object.assign(
                                              {
                                                officeId:
                                                  _vm.$store.getters
                                                    .currentOfficeId
                                              },
                                              item.subType
                                            ),
                                            "clear-not-match": !item.lock,
                                            filterable: "",
                                            disabled:
                                              item.lock ||
                                              item.defaultConditionVal ===
                                                _vm.AdvancedSearchConsts
                                                  .OPERATOR_IS_NULL.code,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            "default-value":
                                              item.itemValue instanceof Array
                                                ? ""
                                                : item.itemValue,
                                            "callback-method-type": "obj",
                                            "options-width": "300px",
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                  ]
                                : _vm._e(),
                              item.itemType === "allUser"
                                ? [
                                    _c("cargo-advance-select", {
                                      key: "user-single",
                                      ref:
                                        "" +
                                        item.itemName +
                                        item.itemType +
                                        _vm.selectedConfigValue,
                                      refInFor: true,
                                      attrs: {
                                        "select-type":
                                          _vm.selectTypeNames.basic_data_User,
                                        "method-params": { officeId: 0 },
                                        "clear-not-match": true,
                                        filterable: "",
                                        disabled: item.lock,
                                        "callback-params": {
                                          refCode: item.itemName
                                        },
                                        "default-value":
                                          item.itemValue instanceof Array
                                            ? ""
                                            : item.itemValue,
                                        multiple: item.multiple === 1,
                                        "default-multiple-value":
                                          item.multiple === 1
                                            ? item.itemValue
                                            : [],
                                        "callback-method-type": "obj",
                                        "options-width": "300px",
                                        headers: item.headers || [],
                                        fields: item.fields || [],
                                        "tag-name": item.tagName,
                                        "tag-value": item.tagValue,
                                        placeholder: _vm.emptyPlaceholder
                                      },
                                      on: {
                                        enter: _vm.onAdvSelectEnter,
                                        parentCallBack: _vm.getValueFromChild
                                      }
                                    })
                                  ]
                                : _vm._e(),
                              item.itemType === "allOfficeUser"
                                ? [
                                    item.defaultConditionVal === "IN" ||
                                    item.defaultConditionVal === "NOT IN"
                                      ? _c("cargo-advance-select", {
                                          key: "user-multiple",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_User,
                                            url:
                                              _vm.url.sys
                                                .getUsersByPrivilegeDetail,
                                            cache: false,
                                            "method-params": Object.assign(
                                              {
                                                officeId:
                                                  _vm.$store.getters
                                                    .currentOfficeId === 1
                                                    ? ""
                                                    : _vm.$store.getters
                                                        .currentOfficeId
                                              },
                                              item.subType
                                            ),
                                            "clear-not-match": true,
                                            filterable: "",
                                            disabled: item.lock,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            "default-multiple-value":
                                              item.itemValue instanceof Array
                                                ? item.itemValue
                                                : [],
                                            multiple: true,
                                            "callback-method-type": "obj",
                                            "options-width": "300px",
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          key: "user-single",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_User,
                                            url:
                                              _vm.url.sys
                                                .getUsersByPrivilegeDetail,
                                            cache: false,
                                            "method-params": Object.assign(
                                              {
                                                officeId:
                                                  _vm.$store.getters
                                                    .currentOfficeId === 1
                                                    ? ""
                                                    : _vm.$store.getters
                                                        .currentOfficeId
                                              },
                                              item.subType
                                            ),
                                            "clear-not-match": true,
                                            filterable: "",
                                            disabled: item.lock,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            "default-value":
                                              item.itemValue instanceof Array
                                                ? ""
                                                : item.itemValue,
                                            "callback-method-type": "obj",
                                            "options-width": "300px",
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                  ]
                                : _vm._e(),
                              item.itemType === "allUser2"
                                ? [
                                    item.defaultConditionVal === "IN" ||
                                    item.defaultConditionVal === "NOT IN"
                                      ? _c("cargo-advance-select", {
                                          key: "user-multiple",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_User,
                                            url:
                                              _vm.url.sys
                                                .getUsersByPrivilegeDetail,
                                            cache: false,
                                            "method-params": Object.assign(
                                              item.subType
                                            ),
                                            "clear-not-match": true,
                                            filterable: "",
                                            disabled: item.lock,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            "default-multiple-value":
                                              item.itemValue instanceof Array
                                                ? item.itemValue
                                                : [],
                                            multiple: true,
                                            "callback-method-type": "obj",
                                            "options-width": "300px",
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          key: "user-single",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_User,
                                            url:
                                              _vm.url.sys
                                                .getUsersByPrivilegeDetail,
                                            cache: false,
                                            "method-params": Object.assign(
                                              item.subType
                                            ),
                                            "clear-not-match": true,
                                            filterable: "",
                                            disabled: item.lock,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            "default-value":
                                              item.itemValue instanceof Array
                                                ? ""
                                                : item.itemValue,
                                            "callback-method-type": "obj",
                                            "options-width": "300px",
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                  ]
                                : _vm._e(),
                              item.itemType === "chargeItem"
                                ? [
                                    item.defaultConditionVal === "IN" ||
                                    item.defaultConditionVal === "NOT IN"
                                      ? _c("cargo-advance-select", {
                                          key: "chargeItem-multiple",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_ChargeItem,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            url: "",
                                            disabled: item.lock,
                                            "default-multiple-value":
                                              item.itemValue instanceof Array
                                                ? item.itemValue
                                                : [],
                                            multiple: true,
                                            filterable: "",
                                            "options-width": "450px",
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          key: "chargeItem-single",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_ChargeItem,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            url: "",
                                            disabled: item.lock,
                                            "default-value":
                                              item.itemValue instanceof Array
                                                ? ""
                                                : item.itemValue,
                                            filterable: "",
                                            "options-width": "450px",
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                  ]
                                : _vm._e(),
                              item.itemType === "settlementMethod"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "select-type":
                                        _vm.selectTypeNames
                                          .local_cache_SettlementMethod,
                                      "default-multiple-value":
                                        item.multiple === 1
                                          ? item.itemValue
                                          : [],
                                      "default-value":
                                        item.multiple === 1
                                          ? ""
                                          : item.itemValue,
                                      multiple: item.multiple == 1,
                                      filterable: "",
                                      disabled: item.lock,
                                      "options-width": "450px",
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "settlementType"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "select-type":
                                        _vm.selectTypeNames
                                          .local_cache_SettlementType,
                                      disabled: item.lock,
                                      "default-multiple-value":
                                        item.multiple === 1
                                          ? item.itemValue
                                          : [],
                                      "default-value":
                                        item.multiple === 1
                                          ? ""
                                          : item.itemValue,
                                      multiple: item.multiple == 1,
                                      filterable: "",
                                      "options-width": "450px",
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "company"
                                ? [
                                    item.fieldType === "FIELD_CUSTOMER_BROKER"
                                      ? _c("cargo-advance-select", {
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Company,
                                            "method-params": {
                                              customsBroker: true,
                                              officeIds: item.subType
                                                ? item.subType.officeIds || null
                                                : null,
                                              includeAllOffice:
                                                item.subType &&
                                                item.subType.includeAllOffice
                                            },
                                            "hand-trigger-value":
                                              _vm.$store.getters
                                                .currentOfficeUuid,
                                            "clear-not-match": true,
                                            filterable: "",
                                            disabled: item.lock,
                                            "callback-params": {
                                              refCode: item.itemName,
                                              fieldType: item.fieldType
                                            },
                                            "default-value": item.itemValue,
                                            "tag-value":
                                              item.tagValue !== ""
                                                ? item.tagValue
                                                : item.subType.tagValue,
                                            "options-width": "300px",
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                      : (item.subType &&
                                          item.subType.useSales) ||
                                        (item.subType &&
                                          item.subType.useSalesCsr &&
                                          _vm.accountObjectControlMode === 2)
                                      ? [
                                          item.defaultConditionVal === "IN" ||
                                          item.defaultConditionVal === "NOT IN"
                                            ? _c("cargo-sales-company-select", {
                                                key: "sales-company-multiple",
                                                ref:
                                                  "" +
                                                  item.itemName +
                                                  item.itemType +
                                                  _vm.selectedConfigValue,
                                                refInFor: true,
                                                attrs: {
                                                  "method-params": _vm.companyMethodParamFilter(
                                                    item
                                                  ),
                                                  "clear-not-match": true,
                                                  disabled: item.lock,
                                                  "contains-no-customer":
                                                    item.subType
                                                      .containsNoCustomer,
                                                  "callback-params": {
                                                    refCode: item.itemName,
                                                    fieldType: item.fieldType
                                                  },
                                                  "default-multiple-value":
                                                    item.itemValue instanceof
                                                    Array
                                                      ? item.itemValue
                                                      : [],
                                                  multiple: true,
                                                  "tag-value":
                                                    item.tagValue !== ""
                                                      ? item.tagValue
                                                      : item.subType.tagValue,
                                                  headers: item.headers || [],
                                                  fields: item.fields || [],
                                                  "tag-name": item.tagName,
                                                  placeholder:
                                                    _vm.emptyPlaceholder,
                                                  "use-account-object-control-mode":
                                                    item.subType
                                                      .useAccountObjectControlMode
                                                },
                                                on: {
                                                  enter: _vm.onAdvSelectEnter,
                                                  parentCallBack:
                                                    _vm.getValueFromChild
                                                }
                                              })
                                            : _c("cargo-sales-company-select", {
                                                key: "sales-company-single",
                                                ref:
                                                  "" +
                                                  item.itemName +
                                                  item.itemType +
                                                  _vm.selectedConfigValue,
                                                refInFor: true,
                                                attrs: {
                                                  "method-params": _vm.companyMethodParamFilter(
                                                    item
                                                  ),
                                                  "clear-not-match": true,
                                                  disabled: item.lock,
                                                  "contains-no-customer":
                                                    item.subType
                                                      .containsNoCustomer,
                                                  "callback-params": {
                                                    refCode: item.itemName,
                                                    fieldType: item.fieldType
                                                  },
                                                  "default-value":
                                                    item.itemValue instanceof
                                                    Array
                                                      ? ""
                                                      : item.itemValue,
                                                  "tag-value":
                                                    item.tagValue !== ""
                                                      ? item.tagValue
                                                      : item.subType.tagValue,
                                                  headers: item.headers || [],
                                                  fields: item.fields || [],
                                                  "tag-name": item.tagName,
                                                  placeholder:
                                                    _vm.emptyPlaceholder,
                                                  "use-account-object-control-mode":
                                                    item.subType
                                                      .useAccountObjectControlMode
                                                },
                                                on: {
                                                  enter: _vm.onAdvSelectEnter,
                                                  parentCallBack:
                                                    _vm.getValueFromChild
                                                }
                                              })
                                        ]
                                      : [
                                          item.defaultConditionVal === "IN" ||
                                          item.defaultConditionVal === "NOT IN"
                                            ? _c("cargo-advance-select", {
                                                key: "company-multiple",
                                                ref:
                                                  "" +
                                                  item.itemName +
                                                  item.itemType +
                                                  _vm.selectedConfigValue,
                                                refInFor: true,
                                                attrs: {
                                                  "select-type":
                                                    _vm.selectTypeNames
                                                      .basic_data_Company,
                                                  "method-params": _vm.companyMethodParamFilter(
                                                    item
                                                  ),
                                                  "hand-trigger-value":
                                                    _vm.$store.getters
                                                      .currentOfficeUuid,
                                                  "clear-not-match": true,
                                                  filterable: "",
                                                  disabled: item.lock,
                                                  "callback-params": {
                                                    refCode: item.itemName,
                                                    fieldType: item.fieldType
                                                  },
                                                  "default-multiple-value":
                                                    item.itemValue instanceof
                                                    Array
                                                      ? item.itemValue
                                                      : [],
                                                  multiple: true,
                                                  "tag-value":
                                                    item.tagValue !== ""
                                                      ? item.tagValue
                                                      : item.subType.tagValue,
                                                  "options-width": "300px",
                                                  headers: item.headers || [],
                                                  fields: item.fields || [],
                                                  "tag-name": item.tagName,
                                                  placeholder:
                                                    _vm.emptyPlaceholder
                                                },
                                                on: {
                                                  enter: _vm.onAdvSelectEnter,
                                                  parentCallBack:
                                                    _vm.getValueFromChild
                                                }
                                              })
                                            : _c("cargo-advance-select", {
                                                key: "company-single",
                                                ref:
                                                  "" +
                                                  item.itemName +
                                                  item.itemType +
                                                  _vm.selectedConfigValue,
                                                refInFor: true,
                                                attrs: {
                                                  "select-type":
                                                    _vm.selectTypeNames
                                                      .basic_data_Company,
                                                  "method-params": _vm.companyMethodParamFilter(
                                                    item
                                                  ),
                                                  "hand-trigger-value":
                                                    _vm.$store.getters
                                                      .currentOfficeUuid,
                                                  "clear-not-match": true,
                                                  filterable: "",
                                                  disabled: item.lock,
                                                  "callback-params": {
                                                    refCode: item.itemName,
                                                    fieldType: item.fieldType
                                                  },
                                                  "default-value":
                                                    item.itemValue instanceof
                                                    Array
                                                      ? ""
                                                      : item.itemValue,
                                                  "tag-value":
                                                    item.tagValue !== ""
                                                      ? item.tagValue
                                                      : item.subType.tagValue,
                                                  "options-width": "300px",
                                                  headers: item.headers || [],
                                                  fields: item.fields || [],
                                                  "tag-name": item.tagName,
                                                  placeholder:
                                                    _vm.emptyPlaceholder
                                                },
                                                on: {
                                                  enter: _vm.onAdvSelectEnter,
                                                  parentCallBack:
                                                    _vm.getValueFromChild
                                                }
                                              })
                                        ]
                                  ]
                                : _vm._e(),
                              item.itemType === "postCode"
                                ? _c("cargo-post-code-select", {
                                    attrs: { "default-value": item.itemValue },
                                    on: {
                                      change: function(p) {
                                        return (item.itemValue = p
                                          ? p.uuid
                                          : "")
                                      }
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "railwayStation"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_RailwayStation,
                                      filterable: "",
                                      disabled: item.lock,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-value": item.itemValue,
                                      "options-width": "300px",
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "currency"
                                ? [
                                    item.defaultConditionVal === "IN" ||
                                    item.defaultConditionVal === "NOT IN"
                                      ? _c("cargo-advance-select", {
                                          key: "currency-multiple",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Currency,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            url: "",
                                            filterable: "",
                                            multiple: true,
                                            disabled: item.lock,
                                            "default-multiple-value":
                                              item.itemValue instanceof Array
                                                ? item.itemValue
                                                : [],
                                            "options-width": "200px",
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          key: "currency-single",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Currency,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            url: "",
                                            filterable: "",
                                            multiple: item.multiple === 1,
                                            disabled: item.lock,
                                            "default-multiple-value":
                                              item.itemValue instanceof Array
                                                ? item.itemValue
                                                : [],
                                            "default-value":
                                              item.itemValue instanceof Array
                                                ? ""
                                                : item.itemValue,
                                            "options-width": "200px",
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                  ]
                                : _vm._e(),
                              item.itemType === "incoTerm"
                                ? [
                                    item.defaultConditionVal === "IN" ||
                                    item.defaultConditionVal === "NOT IN"
                                      ? _c("cargo-advance-select", {
                                          key: "incoTerm-multiple",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_IncoTerm,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            url: "",
                                            filterable: "",
                                            multiple: true,
                                            disabled: item.lock,
                                            "default-multiple-value":
                                              item.multiple === 1
                                                ? item.itemValue
                                                : [],
                                            "default-value":
                                              item.multiple === 1
                                                ? ""
                                                : item.itemValue,
                                            "options-width": "200px",
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          key: "incoTerm-single",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_IncoTerm,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            url: "",
                                            filterable: "",
                                            multiple: false,
                                            disabled: item.lock,
                                            "default-multiple-value":
                                              item.multiple === 1
                                                ? item.itemValue
                                                : [],
                                            "default-value":
                                              item.multiple === 1
                                                ? ""
                                                : item.itemValue,
                                            "options-width": "200px",
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                  ]
                                : _vm._e(),
                              item.itemType === "shippingTerm"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_ShippingTerm,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      url: "",
                                      filterable: "",
                                      multiple: item.multiple === 1,
                                      disabled: item.lock,
                                      "default-multiple-value":
                                        item.multiple === 1
                                          ? item.itemValue
                                          : [],
                                      "default-value":
                                        item.multiple === 1
                                          ? ""
                                          : item.itemValue,
                                      "options-width": "200px",
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "serviceProduct"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_AirServiceProduct,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      url: "",
                                      filterable: "",
                                      multiple: item.multiple === 1,
                                      disabled: item.lock,
                                      "default-multiple-value":
                                        item.multiple === 1
                                          ? item.itemValue
                                          : [],
                                      "default-value":
                                        item.multiple === 1
                                          ? ""
                                          : item.itemValue,
                                      "options-width": "200px",
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "orderFormType"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_OrderFormType,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      url: "",
                                      filterable: "",
                                      multiple: item.multiple === 1,
                                      disabled: item.lock,
                                      "default-value": item.itemValue,
                                      "options-width": "200px",
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "office"
                                ? [
                                    item.subType &&
                                    item.subType.includeChildOffice
                                      ? _c("office-with-child-select", {
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            "default-value": item.itemValue,
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            filterable: "",
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            "select-type":
                                              item.subType &&
                                              item.subType.includeAllOffice
                                                ? _vm.selectTypeNames
                                                    .basic_data_Office_All
                                                : _vm.selectTypeNames
                                                    .basic_data_Office,
                                            "default-value":
                                              item.multiple === 1
                                                ? ""
                                                : item.itemValue,
                                            "method-params": {},
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder,
                                            multiple: item.multiple === 1,
                                            "default-multiple-value":
                                              item.multiple === 1
                                                ? item.itemValue
                                                : []
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                  ]
                                : _vm._e(),
                              item.itemType === "autoOffice"
                                ? _c("cargo-owned-branch-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      multiple: item.multiple === 1,
                                      clearable: true,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    model: {
                                      value: item.itemValue,
                                      callback: function($$v) {
                                        _vm.$set(item, "itemValue", $$v)
                                      },
                                      expression: "item.itemValue"
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "department"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      disabled: item.lock,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_Department,
                                      "method-params": {
                                        officeUuid:
                                          _vm.$store.getters.currentOfficeUuid
                                      },
                                      "clear-not-match": true,
                                      filterable: "",
                                      placeholder: _vm.emptyPlaceholder,
                                      multiple: item.multiple === 1,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-multiple-value":
                                        item.multiple === 1
                                          ? item.itemValue
                                          : [],
                                      "default-value":
                                        item.multiple === 1
                                          ? ""
                                          : item.itemValue,
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "department2"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      disabled: item.lock,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_Department_All,
                                      "method-params": {
                                        officeUuid:
                                          _vm.$store.getters.currentOfficeUuid,
                                        clearing: true
                                      },
                                      "clear-not-match": true,
                                      filterable: "",
                                      placeholder: _vm.emptyPlaceholder,
                                      multiple: item.multiple === 1,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-multiple-value":
                                        item.multiple === 1
                                          ? item.itemValue
                                          : [],
                                      "default-value":
                                        item.multiple === 1
                                          ? ""
                                          : item.itemValue,
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "department3"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      disabled: item.lock,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_OfficeDepartmentAllDepartmentMap,
                                      "method-params": {
                                        officeId:
                                          _vm.$store.getters.currentOfficeId
                                      },
                                      "clear-not-match": true,
                                      filterable: "",
                                      multiple: item.multiple === 1,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-multiple-value": item.itemValue,
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "department4"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      disabled: item.lock,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_OfficeAllDepartmentMap,
                                      "method-params": {
                                        officeId:
                                          _vm.$store.getters.currentOfficeId
                                      },
                                      "clear-not-match": true,
                                      filterable: "",
                                      multiple: item.multiple === 1,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-multiple-value":
                                        item.multiple === 1
                                          ? item.itemValue
                                          : [],
                                      "default-value":
                                        item.multiple === 1
                                          ? ""
                                          : item.itemValue,
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "department5"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      disabled: item.lock,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_Department_All,
                                      "method-params":
                                        item.subType &&
                                        item.subType.includeAllOffice
                                          ? {}
                                          : {
                                              officeUuid:
                                                _vm.$store.getters
                                                  .currentOfficeUuid
                                            },
                                      "clear-not-match": true,
                                      filterable: "",
                                      placeholder: _vm.emptyPlaceholder,
                                      multiple: item.multiple === 1,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-multiple-value":
                                        item.multiple === 1
                                          ? item.itemValue
                                          : [],
                                      "default-value":
                                        item.multiple === 1
                                          ? ""
                                          : item.itemValue,
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "region"
                                ? [
                                    item.defaultConditionVal ===
                                    _vm.AdvancedSearchConsts.OPERATOR_IN.code
                                      ? _c("cargo-advance-select", {
                                          key:
                                            "region-m-" +
                                            item.itemName +
                                            "-" +
                                            item.defaultConditionVal +
                                            "-" +
                                            _vm.selectedConfigValue,
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            disabled: item.lock,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Region,
                                            filterable: "",
                                            multiple: true,
                                            "callback-params": {
                                              refCode: item.itemName,
                                              itemType: "region"
                                            },
                                            "default-multiple-value":
                                              item.itemValue instanceof Array
                                                ? item.itemValue
                                                : [],
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          key:
                                            "region-s-" +
                                            item.itemName +
                                            "-" +
                                            item.defaultConditionVal +
                                            "-" +
                                            _vm.selectedConfigValue,
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            disabled: item.lock,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Region,
                                            filterable: "",
                                            multiple: false,
                                            "callback-params": {
                                              refCode: item.itemName,
                                              itemType: "region"
                                            },
                                            "default-multiple-value": [],
                                            "default-value":
                                              item.itemValue instanceof Array
                                                ? item.itemValue[0] || ""
                                                : item.itemValue,
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                  ]
                                : _vm._e(),
                              item.itemType === "blMode"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      disabled: item.lock,
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_BlMode,
                                      "method-params": item.subType,
                                      filterable: "",
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-multiple-value":
                                        item.multiple === 1
                                          ? item.itemValue
                                          : [],
                                      "default-value":
                                        item.multiple === 1
                                          ? ""
                                          : item.itemValue,
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "cutomJobType"
                                ? [
                                    item.subType === "cascader"
                                      ? _c("cargo-cascader", {
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            disabled: item.lock,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_CutomJobType,
                                            filterable: "",
                                            "group-field": "type",
                                            "railway-common-data-source": false,
                                            "group-label-map": {
                                              SE: _vm.$t(
                                                "CargoMsg.Cargo_OceanExport"
                                              ),
                                              SI: _vm.$t(
                                                "CargoMsg.Cargo_OceanImport"
                                              ),
                                              AE: _vm.$t(
                                                "CargoMsg.Cargo_AirExport"
                                              ),
                                              AI: _vm.$t(
                                                "CargoMsg.Cargo_AirImport"
                                              ),
                                              RE: _vm.$t(
                                                "CargoMsg.Cargo_RailwayExport"
                                              ),
                                              RI: _vm.$t(
                                                "CargoMsg.Cargo_RailwayImport"
                                              ),
                                              IE: _vm.$t(
                                                "CargoMsg.Cargo_IntegratedJob"
                                              )
                                            },
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: { enter: _vm.onAdvSelectEnter },
                                          model: {
                                            value: item.itemValue,
                                            callback: function($$v) {
                                              _vm.$set(item, "itemValue", $$v)
                                            },
                                            expression: "item.itemValue"
                                          }
                                        })
                                      : item.subType === "RE"
                                      ? _c("cargo-cascader", {
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            disabled: item.lock,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_CutomJobType,
                                            filterable: "",
                                            "group-field": "type",
                                            "filter-null-key": true,
                                            "railway-common-data-source": false,
                                            "group-label-map": {
                                              RE: _vm.$t(
                                                "CargoMsg.Cargo_RailwayExport"
                                              ),
                                              RI: _vm.$t(
                                                "CargoMsg.Cargo_RailwayImport"
                                              )
                                            },
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: { enter: _vm.onAdvSelectEnter },
                                          model: {
                                            value: item.itemValue,
                                            callback: function($$v) {
                                              _vm.$set(item, "itemValue", $$v)
                                            },
                                            expression: "item.itemValue"
                                          }
                                        })
                                      : [
                                          item.defaultConditionVal === "IN"
                                            ? _c("cargo-advance-select", {
                                                key: "cutomJobType-multiple",
                                                ref:
                                                  "" +
                                                  item.itemName +
                                                  item.itemType +
                                                  _vm.selectedConfigValue,
                                                refInFor: true,
                                                attrs: {
                                                  disabled: item.lock,
                                                  "select-type":
                                                    _vm.selectTypeNames
                                                      .basic_data_CutomJobType,
                                                  filterable: "",
                                                  "method-params": item.subType,
                                                  "callback-params": {
                                                    refCode: item.itemName
                                                  },
                                                  "default-multiple-value":
                                                    item.itemValue instanceof
                                                    Array
                                                      ? item.itemValue
                                                      : [],
                                                  multiple: true,
                                                  headers: item.headers || [],
                                                  fields: item.fields || [],
                                                  "tag-name": item.tagName,
                                                  "tag-value": item.tagValue,
                                                  placeholder:
                                                    _vm.emptyPlaceholder
                                                },
                                                on: {
                                                  enter: _vm.onAdvSelectEnter,
                                                  parentCallBack:
                                                    _vm.getValueFromChild
                                                }
                                              })
                                            : _c("cargo-advance-select", {
                                                key: "cutomJobType-single",
                                                ref:
                                                  "" +
                                                  item.itemName +
                                                  item.itemType +
                                                  _vm.selectedConfigValue,
                                                refInFor: true,
                                                attrs: {
                                                  disabled: item.lock,
                                                  "select-type":
                                                    _vm.selectTypeNames
                                                      .basic_data_CutomJobType,
                                                  "method-params": item.subType,
                                                  filterable: "",
                                                  "callback-params": {
                                                    refCode: item.itemName
                                                  },
                                                  "default-value":
                                                    item.itemValue,
                                                  headers: item.headers || [],
                                                  fields: item.fields || [],
                                                  "tag-name": item.tagName,
                                                  "tag-value": item.tagValue,
                                                  placeholder:
                                                    _vm.emptyPlaceholder
                                                },
                                                on: {
                                                  enter: _vm.onAdvSelectEnter,
                                                  parentCallBack:
                                                    _vm.getValueFromChild
                                                }
                                              })
                                        ]
                                  ]
                                : _vm._e(),
                              item.itemType === "customerType"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      disabled: item.lock,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_CustomerType,
                                      filterable: "",
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-value": item.itemValue,
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "paymentTerm"
                                ? [
                                    item.defaultConditionVal === "IN" ||
                                    item.defaultConditionVal === "NOT IN"
                                      ? _c("cargo-advance-select", {
                                          key: "payment-term-multiple",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            disabled: item.lock,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_PaymentTerm,
                                            "custom-label":
                                              _vm.paymentTermOptionLabel,
                                            filterable: "",
                                            multiple: true,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            "default-multiple-value":
                                              item.itemValue instanceof Array
                                                ? item.itemValue
                                                : [],
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          key: "payment-term-single",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            disabled: item.lock,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_PaymentTerm,
                                            "custom-label":
                                              _vm.paymentTermOptionLabel,
                                            filterable: "",
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            "default-value":
                                              item.itemValue instanceof Array
                                                ? ""
                                                : item.itemValue,
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                  ]
                                : _vm._e(),
                              item.itemType === "cargoType"
                                ? [
                                    item.fieldType === "FIELD_SEA_CARGOTYPE"
                                      ? _c("cargo-advance-select", {
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            disabled: item.lock,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_CargoType,
                                            filterable: "",
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            "default-value": item.itemValue,
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                      : _vm._e(),
                                    item.fieldType ===
                                    "FIELD_MULTI_DROP_DOWN_LIST"
                                      ? _c("cargo-advance-select", {
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            disabled: item.lock,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_CargoType,
                                            filterable: "",
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            "default-multiple-value":
                                              item.itemValue instanceof Array
                                                ? item.itemValue
                                                : [],
                                            multiple: true,
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                : _vm._e(),
                              item.itemType === "cargoTerminalOperation"
                                ? [
                                    item.defaultConditionVal === "IN" ||
                                    item.defaultConditionVal === "NOT IN"
                                      ? _c("cargo-advance-select", {
                                          key:
                                            "cargo-terminal-operation-multiple",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_AirportCargoTerminal,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            url: "",
                                            filterable: "",
                                            multiple: true,
                                            disabled: item.lock,
                                            "method-params": item.subType,
                                            "default-multiple-value":
                                              item.itemValue instanceof Array
                                                ? item.itemValue
                                                : [],
                                            "options-width": "200px",
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          key:
                                            "cargo-terminal-operation-single",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_AirportCargoTerminal,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            url: "",
                                            filterable: "",
                                            multiple: item.multiple === 1,
                                            disabled: item.lock,
                                            "method-params": item.subType,
                                            "default-multiple-value":
                                              item.itemValue instanceof Array
                                                ? item.itemValue
                                                : [],
                                            "default-value":
                                              item.itemValue instanceof Array
                                                ? ""
                                                : item.itemValue,
                                            "options-width": "200px",
                                            headers: item.headers || [],
                                            fields: item.fields || [],
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                  ]
                                : _vm._e(),
                              item.itemType === "tradeTerm"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      disabled: item.lock,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_TradeTerm,
                                      filterable: "",
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-value": item.itemValue,
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "fileType"
                                ? [
                                    item.subType === "cascader"
                                      ? _c("cargo-cascader", {
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            disabled: item.lock,
                                            "static-options": item.dataProvider,
                                            filterable: "",
                                            "group-field": "ifFba",
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: { enter: _vm.onAdvSelectEnter },
                                          model: {
                                            value: item.itemValue,
                                            callback: function($$v) {
                                              _vm.$set(item, "itemValue", $$v)
                                            },
                                            expression: "item.itemValue"
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                : _vm._e(),
                              item.itemType === "overseaWarehouse"
                                ? [
                                    item.subType === "cascader"
                                      ? _c("cargo-cascader", {
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            disabled: item.lock,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_OverseaWarehouse,
                                            filterable: "",
                                            "group-field": "ifFba",
                                            "group-label-map": {
                                              true: "FBA",
                                              false: _vm.$t(
                                                "FbaJob.otherOverseaWarehouse"
                                              )
                                            },
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: { enter: _vm.onAdvSelectEnter },
                                          model: {
                                            value: item.itemValue,
                                            callback: function($$v) {
                                              _vm.$set(item, "itemValue", $$v)
                                            },
                                            expression: "item.itemValue"
                                          }
                                        })
                                      : [
                                          item.defaultConditionVal === "IN" ||
                                          item.defaultConditionVal === "NOT IN"
                                            ? _c("cargo-advance-select", {
                                                ref:
                                                  "" +
                                                  item.itemName +
                                                  item.itemType +
                                                  _vm.selectedConfigValue,
                                                refInFor: true,
                                                attrs: {
                                                  disabled: item.lock,
                                                  "select-type":
                                                    _vm.selectTypeNames
                                                      .basic_data_OverseaWarehouse,
                                                  filterable: "",
                                                  "method-params": item.subType,
                                                  "callback-params": {
                                                    refCode: item.itemName
                                                  },
                                                  "default-multiple-value":
                                                    item.itemValue instanceof
                                                    Array
                                                      ? item.itemValue
                                                      : [],
                                                  multiple: true,
                                                  headers: item.headers || [],
                                                  fields: item.fields || [],
                                                  "tag-name": item.tagName,
                                                  "tag-value": item.tagValue,
                                                  placeholder:
                                                    _vm.emptyPlaceholder
                                                },
                                                on: {
                                                  enter: _vm.onAdvSelectEnter,
                                                  parentCallBack:
                                                    _vm.getValueFromChild
                                                }
                                              })
                                            : "BATCH" !==
                                              item.defaultConditionVal
                                            ? _c("cargo-advance-select", {
                                                ref:
                                                  "" +
                                                  item.itemName +
                                                  item.itemType +
                                                  _vm.selectedConfigValue,
                                                refInFor: true,
                                                attrs: {
                                                  disabled: item.lock,
                                                  "select-type":
                                                    _vm.selectTypeNames
                                                      .basic_data_OverseaWarehouse,
                                                  filterable: "",
                                                  "method-params": item.subType,
                                                  "callback-params": {
                                                    refCode: item.itemName
                                                  },
                                                  "default-value":
                                                    item.itemValue instanceof
                                                    Array
                                                      ? ""
                                                      : item.itemValue,
                                                  headers: item.headers || [],
                                                  fields: item.fields || [],
                                                  "tag-name": item.tagName,
                                                  "tag-value": item.tagValue,
                                                  placeholder:
                                                    _vm.emptyPlaceholder
                                                },
                                                on: {
                                                  enter: _vm.onAdvSelectEnter,
                                                  parentCallBack:
                                                    _vm.getValueFromChild
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                  ]
                                : _vm._e(),
                              item.itemType === "fbaChannel"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      disabled: item.lock,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_FbaChannel,
                                      filterable: "",
                                      "method-params": item.subType,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-value": item.itemValue,
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "fbaChannel"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      disabled: item.lock,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_FbaChannel,
                                      filterable: "",
                                      "method-params": item.subType,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-value": item.itemValue,
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "valueAddedService"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      disabled: item.lock,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_ValueAddedService,
                                      multiple: item.multiple === 1,
                                      "default-multiple-value":
                                        item.multiple === 1
                                          ? item.itemValue
                                          : [],
                                      filterable: "",
                                      "method-params": item.subType,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-value": item.itemValue,
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "customerSource"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_CustomerSource,
                                      filterable: "",
                                      disabled: item.lock,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-value": item.itemValue,
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "customerSource2"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_CustomerSource,
                                      filterable: "",
                                      disabled: item.lock,
                                      multiple: item.multiple === 1,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-multiple-value":
                                        item.itemValue instanceof Array
                                          ? item.itemValue
                                          : [],
                                      "default-value":
                                        item.multiple === 1
                                          ? ""
                                          : item.itemValue,
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder,
                                      "custom-label": function(p) {
                                        return "" + p.name
                                      }
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "transportType"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_TransportType,
                                      filterable: "",
                                      disabled: item.lock,
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      "default-value": item.itemValue,
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "projectName"
                                ? _c("cargo-project-name-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      disabled: item.lock,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    model: {
                                      value: item.itemValue,
                                      callback: function($$v) {
                                        _vm.$set(item, "itemValue", $$v)
                                      },
                                      expression: "item.itemValue"
                                    }
                                  })
                                : item.multiple === 1 &&
                                  !!item.dropdownDataRef &&
                                  item.dataCacheKey &&
                                  item.dataCacheKey ===
                                    "local_cache_SystemConstants$JOB_STATES"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      disabled: item.lock,
                                      "select-type":
                                        _vm.selectTypeNames[item.dataCacheKey],
                                      "static-options": [].concat(
                                        _vm.JOB_STATES
                                      ),
                                      filterable: "",
                                      "callback-params": {
                                        refCode: item.itemName,
                                        fieldType: item.fieldType
                                      },
                                      "default-multiple-value": _vm.handleJobStates(
                                        item
                                      ),
                                      multiple: "",
                                      placeholder: _vm.emptyPlaceholder,
                                      "options-width": "450px",
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : item.multiple == 1 && !!item.dropdownDataRef
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      disabled: item.lock,
                                      "select-type":
                                        _vm.selectTypeNames[item.dataCacheKey],
                                      filterable: "",
                                      "callback-params": {
                                        refCode: item.itemName,
                                        fieldType: item.fieldType
                                      },
                                      "default-multiple-value": item.itemValue,
                                      multiple: "",
                                      placeholder: _vm.emptyPlaceholder,
                                      "options-width": "450px",
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : item.multiple != 1 && !!item.dropdownDataRef
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      disabled: item.lock,
                                      "select-type":
                                        _vm.selectTypeNames[item.dataCacheKey],
                                      filterable: "",
                                      "callback-params": {
                                        refCode: item.itemName,
                                        fieldType: item.fieldType
                                      },
                                      "default-value": item.itemValue,
                                      "options-width": "450px",
                                      placeholder: _vm.emptyPlaceholder,
                                      headers: item.headers || [],
                                      fields: item.fields || [],
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : item.itemType === "advanceSelect"
                                ? _c("cargo-advance-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      filterable: "",
                                      cache: false,
                                      "select-type":
                                        _vm.selectTypeNames[item.dataCacheKey],
                                      disabled:
                                        item.defaultConditionVal ===
                                          "IS NULL" || item.lock,
                                      headers: item.headers,
                                      fields: item.fields,
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      url: item.url,
                                      "method-params": item.methodParams,
                                      "static-options": item.valueExpression
                                        ? item.valueExpression.valueContent
                                        : [],
                                      "callback-params": {
                                        refCode: item.itemName
                                      },
                                      multiple: item.multiple === 1,
                                      "default-multiple-value":
                                        item.multiple === 1
                                          ? item.itemValue
                                          : [],
                                      "default-value":
                                        item.multiple === 1
                                          ? ""
                                          : item.itemValue,
                                      placeholder: _vm.emptyPlaceholder,
                                      "filter-type": item.filterType || "",
                                      page:
                                        item.subType && item.subType.page
                                          ? item.subType.page
                                          : false,
                                      "page-size":
                                        item.subType && item.subType.pageSize
                                          ? item.subType.pageSize
                                          : 50
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "advanceSelect2"
                                ? [
                                    item.defaultConditionVal === "IN" ||
                                    item.defaultConditionVal === "NOT IN"
                                      ? _c("cargo-advance-select", {
                                          key: "multiple",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            filterable: "",
                                            cache: false,
                                            "select-type":
                                              _vm.selectTypeNames[
                                                item.dataCacheKey
                                              ],
                                            disabled: item.lock,
                                            headers: item.headers,
                                            multiple: true,
                                            fields: item.fields,
                                            "filter-tag-names":
                                              item.filterTagNames,
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            url: item.url,
                                            "method-params": item.methodParams,
                                            "static-options": item.valueExpression
                                              ? item.valueExpression
                                                  .valueContent
                                              : [],
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            "default-multiple-value":
                                              item.itemValue instanceof Array
                                                ? item.itemValue
                                                : [],
                                            placeholder: _vm.emptyPlaceholder,
                                            "filter-type": item.filterType || ""
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          key: "single",
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            filterable: "",
                                            cache: false,
                                            "select-type":
                                              _vm.selectTypeNames[
                                                item.dataCacheKey
                                              ],
                                            disabled: item.lock,
                                            headers: item.headers,
                                            fields: item.fields,
                                            "filter-tag-names":
                                              item.filterTagNames,
                                            "tag-name": item.tagName,
                                            "tag-value": item.tagValue,
                                            url: item.url,
                                            "method-params": item.methodParams,
                                            "static-options": item.valueExpression
                                              ? item.valueExpression
                                                  .valueContent
                                              : [],
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            multiple: false,
                                            "default-value":
                                              item.itemValue instanceof Array
                                                ? ""
                                                : item.itemValue,
                                            placeholder: _vm.emptyPlaceholder,
                                            "filter-type": item.filterType || ""
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                  ]
                                : item.itemType === "sopTemplate"
                                ? [
                                    item.subType === "cascaderMulti"
                                      ? _c("cargo-cascader-multi", {
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            filterable: "",
                                            disabled: item.lock,
                                            "select-type":
                                              _vm.selectTypeNames[
                                                item.dataCacheKey
                                              ],
                                            "group-field": "lob",
                                            "group-label-map": {
                                              SE: _vm.$t(
                                                "CargoMsg.Cargo_OceanExport"
                                              ),
                                              SI: _vm.$t(
                                                "CargoMsg.Cargo_OceanImport"
                                              ),
                                              AE: _vm.$t(
                                                "CargoMsg.Cargo_AirExport"
                                              ),
                                              AI: _vm.$t(
                                                "CargoMsg.Cargo_AirImport"
                                              ),
                                              RE: _vm.$t(
                                                "CargoMsg.Cargo_RailwayBusiness"
                                              ),
                                              IE: _vm.$t(
                                                "CargoMsg.Cargo_IntegratedJob"
                                              )
                                            },
                                            "tag-name": "templateName",
                                            "tag-value": "uuid",
                                            placeholder: _vm.emptyPlaceholder,
                                            "copy-flag": false
                                          },
                                          on: { enter: _vm.onAdvSelectEnter },
                                          model: {
                                            value: item.itemValue,
                                            callback: function($$v) {
                                              _vm.$set(item, "itemValue", $$v)
                                            },
                                            expression: "item.itemValue"
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          ref:
                                            "" +
                                            item.itemName +
                                            item.itemType +
                                            _vm.selectedConfigValue,
                                          refInFor: true,
                                          attrs: {
                                            filterable: "",
                                            cache: true,
                                            "callback-params": {
                                              refCode: item.itemName
                                            },
                                            "select-type":
                                              _vm.selectTypeNames[
                                                item.dataCacheKey
                                              ],
                                            "tag-name": "templateName",
                                            "tag-value": "uuid",
                                            "method-params": item.methodParams,
                                            multiple: item.multiple === 1,
                                            "multiple-model":
                                              item.multipleModel,
                                            "default-multiple-value":
                                              item.multiple === 1
                                                ? item.itemValue
                                                : [],
                                            "default-value":
                                              item.multiple === 1
                                                ? ""
                                                : item.itemValue,
                                            placeholder: _vm.emptyPlaceholder
                                          },
                                          on: {
                                            enter: _vm.onAdvSelectEnter,
                                            parentCallBack:
                                              _vm.getValueFromChild
                                          }
                                        })
                                  ]
                                : _vm._e(),
                              item.itemType === "hqCompany"
                                ? _c("cargo-hq-company-select", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      filterable: "",
                                      "select-type":
                                        _vm.selectTypeNames[item.dataCacheKey],
                                      "callback-params": {
                                        refCode: item.itemName,
                                        fieldType: item.fieldType
                                      },
                                      disabled: item.lock,
                                      headers: item.headers,
                                      fields: item.fields,
                                      "tag-name": item.tagName,
                                      "tag-value": item.tagValue,
                                      "method-params": item.methodParams,
                                      "office-id":
                                        _vm.$store.getters.currentOfficeId,
                                      "default-value": item.itemValue,
                                      placeholder: _vm.emptyPlaceholder
                                    },
                                    on: {
                                      enter: _vm.onAdvSelectEnter,
                                      parentCallBack: _vm.getValueFromChild
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "containerLoadTypeCascader"
                                ? _c("container-load-type-cascader", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      "all-lob":
                                        item.fieldType ===
                                        "FIELD_DROP_DOWN_LIST_ALL_LOB",
                                      disabled: item.lock
                                    },
                                    model: {
                                      value: item.itemValue,
                                      callback: function($$v) {
                                        _vm.$set(item, "itemValue", $$v)
                                      },
                                      expression: "item.itemValue"
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "countryAreaCascader"
                                ? _c("country-area-cascader", {
                                    ref:
                                      "" +
                                      item.itemName +
                                      item.itemType +
                                      _vm.selectedConfigValue,
                                    refInFor: true,
                                    attrs: {
                                      value:
                                        item.itemValue instanceof Array
                                          ? item.itemValue
                                          : [],
                                      disabled: item.lock
                                    },
                                    on: {
                                      input: function(val) {
                                        item.itemValue = val
                                      }
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "operationContent"
                                ? [
                                    _c("el-input", {
                                      ref:
                                        "" +
                                        item.itemName +
                                        item.itemType +
                                        _vm.selectedConfigValue,
                                      refInFor: true,
                                      attrs: {
                                        value: item.itemValue
                                          ? item.itemValue.replace(/\n/g, " ")
                                          : "",
                                        size: "mini",
                                        readonly: "",
                                        placeholder: _vm.$t(
                                          "SeaExport.selectOperationRequirement"
                                        )
                                      },
                                      nativeOn: {
                                        dblclick: function($event) {
                                          return _vm.openSelectOperationDialog(
                                            item
                                          )
                                        }
                                      }
                                    }),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !!item.itemValue,
                                            expression: "!!item.itemValue"
                                          }
                                        ],
                                        attrs: {
                                          size: "mini",
                                          disabled: item.lock
                                        },
                                        on: {
                                          click: function($event) {
                                            item.itemValue = ""
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Message.Clear")) + " "
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e(),
                              item.itemType === "specialOperationCode"
                                ? [
                                    _c("el-input", {
                                      ref:
                                        "" +
                                        item.itemName +
                                        item.itemType +
                                        _vm.selectedConfigValue,
                                      refInFor: true,
                                      attrs: {
                                        value: item.itemValue,
                                        size: "mini",
                                        readonly: "",
                                        placeholder: _vm.$t(
                                          "SeaExport.selectSpecialOperationCode"
                                        )
                                      },
                                      nativeOn: {
                                        dblclick: function($event) {
                                          return _vm.openSelectSpecialOperationCodeDialog(
                                            item
                                          )
                                        }
                                      }
                                    }),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !!item.itemValue,
                                            expression: "!!item.itemValue"
                                          }
                                        ],
                                        attrs: {
                                          size: "mini",
                                          disabled: item.lock
                                        },
                                        on: {
                                          click: function($event) {
                                            item.itemValue = ""
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Message.Clear")) + " "
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e(),
                              item.itemType === "customCompany"
                                ? _vm._t("customCompany", null, {
                                    item: item,
                                    getValueFromChild: function(p) {
                                      return _vm.getValueFromChild(p)
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "customType1"
                                ? _vm._t("customType1", null, {
                                    item: item,
                                    getValueFromChild: function(p) {
                                      return _vm.getValueFromChild(p)
                                    }
                                  })
                                : _vm._e(),
                              item.itemType === "customType2"
                                ? _vm._t("customType2", null, {
                                    item: item,
                                    getValueFromChild: function(p) {
                                      return _vm.getValueFromChild(p)
                                    }
                                  })
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "cargo-advance-search-dialog",
          attrs: {
            no: "QuerySchemeManagement",
            visible: _vm.isShowSaveAs,
            title: _vm.$t("CargoMsg.Cargo_QuerySchemeManagement"),
            width: "630px",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowSaveAs = $event
            }
          }
        },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              staticClass: "maintain-item-table",
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                data: _vm.perConfigs,
                size: "mini",
                height: "250",
                "tooltip-effect": "dark",
                "highlight-current-row": ""
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_SchemeName"),
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [_vm._v(" " + _vm._s(scope.row.configName) + " ")]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_Default"),
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.bDefault
                              ? _vm.$t("Message.Yes")
                              : _vm.$t("Message.No")
                          )
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_Operation"),
                  width: "150"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          !scope.row.bDefault &&
                          scope.row.configName !== "default"
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: scope.row.configName + "_1",
                                    type: "text",
                                    size: "mini"
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.deleteRowSearchTemplate(
                                        scope.$index,
                                        _vm.perConfigs
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Delete")) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          !scope.row.bDefault
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: scope.row.configName + "_2",
                                    type: "text",
                                    size: "mini"
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.setDefault(
                                        scope.$index,
                                        _vm.perConfigs
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_SetAsDefault")
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "cargo-advance-search-dialog",
          attrs: {
            no: "SelectQueryCriteria",
            visible: _vm.isShowAbc,
            title: _vm.$t("CargoMsg.Cargo_SelectQueryCriteria"),
            width: "900px",
            top: "5vh",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowAbc = $event
            }
          }
        },
        [
          _c(
            "el-input",
            {
              staticStyle: { width: "49%" },
              attrs: {
                placeholder: _vm.$t(
                  "CargoMsg.Cargo_PleaseInputKeyWordsForQuery"
                ),
                clearable: ""
              },
              model: {
                value: _vm.queryFilter,
                callback: function($$v) {
                  _vm.queryFilter = $$v
                },
                expression: "queryFilter"
              }
            },
            [
              _c("i", {
                staticClass: "el-icon-search",
                attrs: { slot: "suffix" },
                slot: "suffix"
              })
            ]
          ),
          _c(
            "div",
            {
              staticStyle: {
                overflow: "hidden",
                display: "flex",
                "justify-content": "space-between"
              }
            },
            [
              _c(
                "div",
                { staticStyle: { width: "49%" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        color: "#409EFF",
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("CargoMsg.Cargo_AllQueryCriteria")) +
                            "【" +
                            _vm._s(_vm.searchItems.length) +
                            _vm._s(_vm.$t("CargoMsg.Cargo_Pcs")) +
                            "】 "
                        )
                      ]),
                      _c(
                        "div",
                        { staticStyle: { width: "183px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "header",
                                no: "SelectAll",
                                type: "text",
                                size: "mini"
                              },
                              on: { click: _vm.toChooseAllSearchItem },
                              slot: "header"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_SelectAll")) + " "
                              )
                            ]
                          ),
                          _vm._v(" / "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "header",
                                no: "InverseSelect",
                                type: "text",
                                size: "mini"
                              },
                              on: { click: _vm.toInvertChooseSearchItem },
                              slot: "header"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_InverseSelect")) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      attrs: {
                        no: "multipleTable",
                        data: _vm.filteredSearchItems,
                        size: "mini",
                        height: "400",
                        "tooltip-effect": "dark"
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "itemLabel",
                          label: "",
                          width: "30",
                          "show-overflow-tooltip": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.selected
                                  ? _c("span", [
                                      _c("i", {
                                        staticClass: "el-icon-success",
                                        staticStyle: { color: "#409EFF" }
                                      })
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "itemLabel",
                          label: _vm.$t("CargoMsg.Cargo_DisplayName"),
                          width: "290",
                          "show-overflow-tooltip": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.i18nAdvSearch(scope.row.itemLabel)
                                    ) +
                                    " "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_Operation"),
                          width: "80"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                !scope.row.lock
                                  ? _c("el-button", {
                                      attrs: {
                                        no: scope.row.itemLabel,
                                        type: "text",
                                        size: "small",
                                        icon: "el-icon-d-arrow-right"
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.selectRow(
                                            scope.$index,
                                            _vm.searchItems
                                          )
                                        }
                                      }
                                    })
                                  : _c("i", { staticClass: "el-icon-lock" })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { width: "49%" } },
                [
                  _c("div", [
                    _c(
                      "div",
                      { staticStyle: { float: "left", color: "#409EFF" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("CargoMsg.Cargo_MyQueryCriteria")) +
                            "【" +
                            _vm._s(_vm.multipleSelection.length) +
                            _vm._s(_vm.$t("CargoMsg.Cargo_Pcs")) +
                            "】 "
                        )
                      ]
                    )
                  ]),
                  _vm.isShowAbc
                    ? _c(
                        "el-table",
                        {
                          ref: "multipleTable",
                          staticClass: "choose-item-table",
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "multipleTable2",
                            data: _vm.multipleSelection,
                            "row-key": function(row) {
                              return row.itemName + row.fieldType
                            },
                            size: "mini",
                            height: "400",
                            "tooltip-effect": "dark"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "itemLabel",
                              label: _vm.$t("CargoMsg.Cargo_DisplayName"),
                              width: "150",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.i18nAdvSearch(
                                              scope.row.itemLabel
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              378053948
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "itemCondition",
                              label: _vm.showCondition
                                ? _vm.$t("CargoMsg.Cargo_ConditionalExpression")
                                : "",
                              width: "155",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      scope.row.itemCondition &&
                                      scope.row.itemCondition.length > 0 &&
                                      _vm.showCondition
                                        ? _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "80px" },
                                              attrs: {
                                                no:
                                                  scope.row.itemLabel +
                                                  "condition",
                                                size: "mini",
                                                placeholder: _vm.$t(
                                                  "CargoMsg.Cargo_PleaseSelect"
                                                )
                                              },
                                              model: {
                                                value:
                                                  scope.row.defaultConditionVal,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "defaultConditionVal",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.defaultConditionVal"
                                              }
                                            },
                                            _vm._l(
                                              scope.row.itemCondition || [],
                                              function(item, index) {
                                                return _c("el-option", {
                                                  key: item.code + "-" + index,
                                                  attrs: {
                                                    label: _vm.i18nAdvSearch(
                                                      "advanceSearchForm." +
                                                        item.englishName
                                                    ),
                                                    value: item.code
                                                  }
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        : _c("div", {
                                            staticStyle: {
                                              width: "80px",
                                              display: "inline-block"
                                            }
                                          })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              735884389
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Operation"),
                              width: "95"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      !scope.row.lock && !scope.row.fix
                                        ? _c("el-button", {
                                            attrs: {
                                              no:
                                                scope.row.itemLabel +
                                                "operation",
                                              type: "text",
                                              size: "small",
                                              icon: "el-icon-close"
                                            },
                                            nativeOn: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.deleteSearchItem(
                                                  scope.$index,
                                                  _vm.multipleSelection
                                                )
                                              }
                                            }
                                          })
                                        : _c("i", {
                                            staticClass: "el-icon-lock"
                                          })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2352050777
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "sopStateTrack",
            "close-on-press-escape": false,
            "close-on-click-modal": false,
            "custom-class": "sop-state-track",
            visible: _vm.sopStateTrack.isShow,
            title: _vm.$t(_vm.sopStateTrack.currentItem.itemLabel),
            width: "1000px",
            "append-to-body": _vm.appendToBody
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.sopStateTrack, "isShow", $event)
            },
            close: _vm.toCancelEditSopStateTrack
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-radio-group",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.sourcePage === "sales" ||
                        _vm.sourcePage === "finance",
                      expression:
                        "sourcePage=== 'sales' || sourcePage === 'finance'"
                    }
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { value: _vm.sopStateLob, no: "sales" },
                  on: { input: _vm.onLobInput }
                },
                [
                  _c("el-radio", { attrs: { no: "SE", label: "SE" } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OceanExport")))
                  ]),
                  _c("el-radio", { attrs: { no: "SI", label: "SI" } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OceanImport")))
                  ]),
                  _c("el-radio", { attrs: { no: "AE", label: "AE" } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AirExport")))
                  ]),
                  _c("el-radio", { attrs: { no: "AI", label: "AI" } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AirImport")))
                  ]),
                  _c("el-radio", { attrs: { no: "RE", label: "RE" } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_RailwayBusiness")))
                  ]),
                  _c("el-radio", { attrs: { no: "IE", label: "IE" } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_IntegratedJob")))
                  ])
                ],
                1
              ),
              _c(
                "el-radio-group",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { no: "operator" },
                  model: {
                    value: _vm.sopStateTrack.dialog.operator,
                    callback: function($$v) {
                      _vm.$set(_vm.sopStateTrack.dialog, "operator", $$v)
                    },
                    expression: "sopStateTrack.dialog.operator"
                  }
                },
                [
                  _c("el-radio", { attrs: { no: "and", label: "and" } }, [
                    _vm._v(_vm._s(_vm.$t("advanceSearchForm.fitAll")))
                  ]),
                  _c("el-radio", { attrs: { no: "or", label: "or" } }, [
                    _vm._v(_vm._s(_vm.$t("advanceSearchForm.fitAny")))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "overflow-y": "auto",
                "overflow-x": "hidden",
                height: "400px",
                "padding-right": "5px",
                "margin-top": "10px"
              }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-width": "150px",
                    inline: true,
                    "label-position": "left"
                  }
                },
                _vm._l(_vm.sopStateTrack.dialog.data, function(track, index) {
                  return _c(
                    "el-form-item",
                    {
                      key: track.code + "-" + index,
                      staticStyle: { width: "48%" },
                      attrs: {
                        label: _vm.isZh ? track.codeCname : track.codeEname
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("div", { staticStyle: { width: "50px" } }, [
                            _vm._v(_vm._s(_vm.$t("advanceSearchForm.In")))
                          ]),
                          _c(
                            "el-select",
                            {
                              ref: "track" + index,
                              refInFor: true,
                              staticClass: "multi-select",
                              attrs: {
                                multiple: "",
                                placeholder: _vm.$t("common.pleaseChoose")
                              },
                              on: {
                                change: function() {
                                  return _vm.convertSelectedToText(
                                    "track" + index
                                  )
                                }
                              },
                              model: {
                                value:
                                  _vm.sopStateTrack.dialog.currentValue[
                                    track.code
                                  ],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.sopStateTrack.dialog.currentValue,
                                    track.code,
                                    $$v
                                  )
                                },
                                expression:
                                  "sopStateTrack.dialog.currentValue[track.code]"
                              }
                            },
                            _vm._l(track.trackingDetail, function(td, index) {
                              return _c("el-option", {
                                key: td.code + "-" + index,
                                attrs: { label: td.codeCname, value: td.code }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.toConfirmEditSopStateTrack }
                },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "reset", type: "danger" },
                  on: { click: _vm.toResetSopStateTrack }
                },
                [_vm._v(_vm._s(_vm.$t("common.reset")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: { click: _vm.toCancelEditSopStateTrack }
                },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "EditTextArea",
            "close-on-press-escape": false,
            "close-on-click-modal": false,
            visible: _vm.isShowEditTextArea,
            title: _vm.currentInputItem.itemLabel,
            width: "500px",
            "append-to-body": _vm.appendToBody
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowEditTextArea = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { "margin-top": "-30px" },
              attrs: { "label-width": "190px", "label-position": "top" }
            },
            [
              _c("div", { staticStyle: { color: "#409EFF" } }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_MultipleWorkNoEnter")))
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    attrs: { size: "mini", type: "textarea", rows: "6" },
                    model: {
                      value: _vm.dialogTextAreaValue,
                      callback: function($$v) {
                        _vm.dialogTextAreaValue = $$v
                      },
                      expression: "dialogTextAreaValue"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "Confirm", type: "primary", size: "mini" },
                  on: { click: _vm.toConfirmEditTextArea }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "Cancel", type: "primary", size: "mini" },
                  on: { click: _vm.toCancelEditTextArea }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "save-modified-dialog",
          attrs: {
            visible: _vm.saveModifiedDialog.visible,
            title: _vm.$t("Message.SaveScheme"),
            width: _vm.$selectByLang(
              "250px",
              "250px",
              "250px",
              "400px",
              "400px",
              "400px"
            ),
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.saveModifiedDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { "label-width": "0" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.saveModifiedDialog.isSaveColumnState,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.saveModifiedDialog,
                            "isSaveColumnState",
                            $$v
                          )
                        },
                        expression: "saveModifiedDialog.isSaveColumnState"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("Message.SaveColumnSettingsSameTime"))
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.doSaveModified }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.saveModifiedDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "save-scheme-dialog",
          attrs: {
            visible: _vm.saveSchemeDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_NewQueryScheme"),
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.saveSchemeDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px", "label-position": "left" } },
            [
              _c("el-form-item", {
                attrs: { label: _vm.$t("CargoMsg.Cargo_SchemeName") }
              }),
              _c(
                "el-form-item",
                { attrs: { "label-width": "0" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.saveSchemeDialog.name,
                      callback: function($$v) {
                        _vm.$set(_vm.saveSchemeDialog, "name", $$v)
                      },
                      expression: "saveSchemeDialog.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { "label-width": "0" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.saveSchemeDialog.isSaveColumnState,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.saveSchemeDialog,
                            "isSaveColumnState",
                            $$v
                          )
                        },
                        expression: "saveSchemeDialog.isSaveColumnState"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("Message.SaveColumnSettingsSameTime"))
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.doSaveScheme } },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.saveSchemeDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.ediStateQueryDialog.isCreate
        ? _c("edi-state-query-dialog", {
            attrs: {
              visible: _vm.ediStateQueryDialog.visible,
              title: _vm.ediStateQueryDialog.title,
              value: _vm.ediStateQueryDialog.value
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.ediStateQueryDialog, "visible", $event)
              },
              callback: _vm.ediStateQueryDialog.callback
            }
          })
        : _vm._e(),
      _vm.selectOperationReqDialog.visible
        ? _c("select-operation-req-dialog", {
            attrs: {
              visible: _vm.selectOperationReqDialog.visible,
              lob: "AE",
              value: _vm.selectOperationReqDialog.value
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.selectOperationReqDialog, "visible", $event)
              },
              callback: _vm.updateOperationItemValue
            }
          })
        : _vm._e(),
      _vm.selectSpecialOperationCodeDialog.visible
        ? _c("select-special-operation-code-dialog", {
            attrs: {
              visible: _vm.selectSpecialOperationCodeDialog.visible,
              lob: "AE",
              value: _vm.selectSpecialOperationCodeDialog.value
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.selectSpecialOperationCodeDialog,
                  "visible",
                  $event
                )
              },
              callback: _vm.updateSpecialOperationCodeItemValue
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }